"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchStudyMetadataRequest_StudyIdentity = exports.FetchStudyMetadataRequest = exports.DeleteStudyMetadataResponse = exports.DeleteStudyMetadataRequest_StudyIdentity = exports.DeleteStudyMetadataRequest = exports.UpdateStudyMetadataResponse = exports.StudyMetadata_MetaValuesEntry = exports.StudyMetadata_Segment = exports.StudyMetadata_SegmentExperiment_ExperimentSettingsEntry = exports.StudyMetadata_SegmentExperiment = exports.StudyMetadata_AdvancedOptions = exports.StudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry = exports.StudyMetadata_WhitelistedCondition = exports.StudyMetadata_WhitelistedUserGroups = exports.StudyMetadata_UserSliceRange = exports.StudyMetadata_Treatment_ExperimentSettingsEntry = exports.StudyMetadata_Treatment_VariableOverrideMetadata = exports.StudyMetadata_Treatment = exports.StudyMetadata_Guid = exports.StudyMetadata_TargetingExpression = exports.StudyMetadata = exports.UpdateStudyMetadataRequest_StudyIdentity = exports.UpdateStudyMetadataRequest = exports.GetConfigsValueByPropertiesResponse = exports.StudyData_VariablesEntry = exports.StudyData = exports.GetConfigOverridesByPropertiesResponse = exports.COFVariableOverride = exports.GetConfigOverridesByRUIDResponse = exports.GetConfigOverridesByRUIDRequest = exports.TargetingProperties = exports.GetConfigOverridesByPropertiesRequest = exports.TargetingInfo = exports.ABStudyServingMetadata = exports.ABTargetingMetadata = exports.GetConfigsValueByPropertiesRequest_ConfigMetadata = exports.GetConfigsValueByPropertiesRequest = exports.Phone = exports.UserAgentInfo = exports.Email = exports.UserInfo = exports.StudyMetadata_TargetingExpression_Property = exports.StudyMetadata_TargetingExpression_PredicateOperator = exports.StudyMetadata_TargetingExpression_Operator = exports.StudyMetadata_SegmentType = exports.StudyMetadata_Status = exports.StudyMetadata_ServePlatform = exports.GetConfigsValueByPropertiesRequest_SourceOfOrigin = exports.SnapProStatus = exports.protobufPackage = void 0;
exports.HealthCheckResponse = exports.HealthCheckRequest = exports.FetchStudyMetadataResponse = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const ruid_1 = require("../common/ruid");
const config_result_1 = require("../cdp/cof/config_result");
const debug_info_1 = require("../cdp/cof/debug_info");
const value_1 = require("../common/value");
const descriptor_1 = require("../google/protobuf/descriptor");
exports.protobufPackage = "snapchat.ab_config_service";
/** ProtoBuf API definition for AB config service. */
/**
 * Mirror of Atlas schema here:
 * https://github.sc-corp.net/Snapchat/atlas/blob/master/user-service/user-service-interface/src/main/proto/com/snapchat/atlas/user/user-data.proto#L287
 */
var SnapProStatus;
(function (SnapProStatus) {
    SnapProStatus[SnapProStatus["UNKNOWN_SNAP_PRO"] = 0] = "UNKNOWN_SNAP_PRO";
    SnapProStatus[SnapProStatus["NOT_SNAP_PRO"] = 1] = "NOT_SNAP_PRO";
    SnapProStatus[SnapProStatus["STANDARD_TIER"] = 2] = "STANDARD_TIER";
    SnapProStatus[SnapProStatus["OFFICIAL_TIER"] = 3] = "OFFICIAL_TIER";
    SnapProStatus[SnapProStatus["PUBLIC_TIER"] = 4] = "PUBLIC_TIER";
    SnapProStatus[SnapProStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SnapProStatus = exports.SnapProStatus || (exports.SnapProStatus = {}));
var GetConfigsValueByPropertiesRequest_SourceOfOrigin;
(function (GetConfigsValueByPropertiesRequest_SourceOfOrigin) {
    GetConfigsValueByPropertiesRequest_SourceOfOrigin[GetConfigsValueByPropertiesRequest_SourceOfOrigin["UNKNOWN_ORIGIN"] = 0] = "UNKNOWN_ORIGIN";
    GetConfigsValueByPropertiesRequest_SourceOfOrigin[GetConfigsValueByPropertiesRequest_SourceOfOrigin["SERVER"] = 1] = "SERVER";
    GetConfigsValueByPropertiesRequest_SourceOfOrigin[GetConfigsValueByPropertiesRequest_SourceOfOrigin["CLIENT"] = 2] = "CLIENT";
    GetConfigsValueByPropertiesRequest_SourceOfOrigin[GetConfigsValueByPropertiesRequest_SourceOfOrigin["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(GetConfigsValueByPropertiesRequest_SourceOfOrigin = exports.GetConfigsValueByPropertiesRequest_SourceOfOrigin || (exports.GetConfigsValueByPropertiesRequest_SourceOfOrigin = {}));
var StudyMetadata_ServePlatform;
(function (StudyMetadata_ServePlatform) {
    StudyMetadata_ServePlatform[StudyMetadata_ServePlatform["UNKNOWN_PLATFORM"] = 0] = "UNKNOWN_PLATFORM";
    StudyMetadata_ServePlatform[StudyMetadata_ServePlatform["SERVER"] = 1] = "SERVER";
    StudyMetadata_ServePlatform[StudyMetadata_ServePlatform["CLIENT"] = 2] = "CLIENT";
    StudyMetadata_ServePlatform[StudyMetadata_ServePlatform["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StudyMetadata_ServePlatform = exports.StudyMetadata_ServePlatform || (exports.StudyMetadata_ServePlatform = {}));
/** Status of the study */
var StudyMetadata_Status;
(function (StudyMetadata_Status) {
    /** UNKNOWN_STATUS - Placeholder, should not happen. */
    StudyMetadata_Status[StudyMetadata_Status["UNKNOWN_STATUS"] = 0] = "UNKNOWN_STATUS";
    /** DEPLOYED - Deployed study. */
    StudyMetadata_Status[StudyMetadata_Status["DEPLOYED"] = 1] = "DEPLOYED";
    /** COMPLETED - Completed study. */
    StudyMetadata_Status[StudyMetadata_Status["COMPLETED"] = 2] = "COMPLETED";
    StudyMetadata_Status[StudyMetadata_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StudyMetadata_Status = exports.StudyMetadata_Status || (exports.StudyMetadata_Status = {}));
/** Type of the segment. */
var StudyMetadata_SegmentType;
(function (StudyMetadata_SegmentType) {
    /** UNKNOWN_SEGMENT - Unknoww/Error */
    StudyMetadata_SegmentType[StudyMetadata_SegmentType["UNKNOWN_SEGMENT"] = 0] = "UNKNOWN_SEGMENT";
    /** STANDARD_SEGMENT - Segment using standard A/B randomization and not used in rollout phase. */
    StudyMetadata_SegmentType[StudyMetadata_SegmentType["STANDARD_SEGMENT"] = 1] = "STANDARD_SEGMENT";
    /** BUDGET_SEGMENT - Segment using Budget AB allocation. */
    StudyMetadata_SegmentType[StudyMetadata_SegmentType["BUDGET_SEGMENT"] = 2] = "BUDGET_SEGMENT";
    /** ROLLOUT_SEGMENT - Segment in rollout phase. */
    StudyMetadata_SegmentType[StudyMetadata_SegmentType["ROLLOUT_SEGMENT"] = 3] = "ROLLOUT_SEGMENT";
    StudyMetadata_SegmentType[StudyMetadata_SegmentType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StudyMetadata_SegmentType = exports.StudyMetadata_SegmentType || (exports.StudyMetadata_SegmentType = {}));
var StudyMetadata_TargetingExpression_Operator;
(function (StudyMetadata_TargetingExpression_Operator) {
    StudyMetadata_TargetingExpression_Operator[StudyMetadata_TargetingExpression_Operator["UNKNOWN_OPERATOR"] = 0] = "UNKNOWN_OPERATOR";
    StudyMetadata_TargetingExpression_Operator[StudyMetadata_TargetingExpression_Operator["AND"] = 1] = "AND";
    StudyMetadata_TargetingExpression_Operator[StudyMetadata_TargetingExpression_Operator["OR"] = 2] = "OR";
    StudyMetadata_TargetingExpression_Operator[StudyMetadata_TargetingExpression_Operator["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StudyMetadata_TargetingExpression_Operator = exports.StudyMetadata_TargetingExpression_Operator || (exports.StudyMetadata_TargetingExpression_Operator = {}));
var StudyMetadata_TargetingExpression_PredicateOperator;
(function (StudyMetadata_TargetingExpression_PredicateOperator) {
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["UNKNOWN_PREDICATE_OPERATOR"] = 0] = "UNKNOWN_PREDICATE_OPERATOR";
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["EQUAL"] = 1] = "EQUAL";
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["NOT_EQUAL"] = 2] = "NOT_EQUAL";
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["GREATER_THAN_OR_EQUAL_TO"] = 3] = "GREATER_THAN_OR_EQUAL_TO";
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["LESS_THAN_OR_EQUAL_TO"] = 4] = "LESS_THAN_OR_EQUAL_TO";
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["IN"] = 5] = "IN";
    StudyMetadata_TargetingExpression_PredicateOperator[StudyMetadata_TargetingExpression_PredicateOperator["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StudyMetadata_TargetingExpression_PredicateOperator = exports.StudyMetadata_TargetingExpression_PredicateOperator || (exports.StudyMetadata_TargetingExpression_PredicateOperator = {}));
var StudyMetadata_TargetingExpression_Property;
(function (StudyMetadata_TargetingExpression_Property) {
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["UNKNOWN_PROPERTY"] = 0] = "UNKNOWN_PROPERTY";
    /**
     * DEVICE_MODEL - The model of the device that runs snapchat app.
     * e.g. SM-G960U
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_MODEL"] = 1] = "DEVICE_MODEL";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["COUNTRY"] = 2] = "COUNTRY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["OS"] = 3] = "OS";
    /**
     * OS_VERSION - Version of the operating system on which the Snapchat app is running.
     * e.g. 4.4.2
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["OS_VERSION"] = 4] = "OS_VERSION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_VERSION"] = 5] = "APP_VERSION";
    /**
     * BUILD_FLAVOR - Build flavor of the snapchat app user is running.
     * e.g. DEBUG, ALPHA, MASTER.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BUILD_FLAVOR"] = 6] = "BUILD_FLAVOR";
    /**
     * USER_ID - The Snapchat userId of the user. This is mainly used for whitelisting users to a specific value.
     * e.g. PII, no example
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_ID"] = 7] = "USER_ID";
    /**
     * LOCALE - The Locale of the users device. This may not be the locale that the app is displaying to the user.
     * See APP_LOCALE
     * e.g. en_us, en_gb, zh_cn
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LOCALE"] = 8] = "LOCALE";
    /**
     * IS_CHARGING - Signal indicating if the device is charging or not, needs to be evaluated on CLIENT side.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_CHARGING"] = 9] = "IS_CHARGING";
    /**
     * BATTERY_LEVEL - Battery level of user's phone.
     * e.g. HIGH, LOW
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BATTERY_LEVEL"] = 10] = "BATTERY_LEVEL";
    /**
     * DEVICE_CLUSTER - Cluster of the device that runs snapchat app.
     * e.g. 0, 1, 2, 3, 4, 5.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_CLUSTER"] = 11] = "DEVICE_CLUSTER";
    /**
     * IS_OFFLINE - Signal indicating if the device is offline or not, needs to be evaluated on CLIENT side.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_OFFLINE"] = 12] = "IS_OFFLINE";
    /**
     * BANDWIDTH - Available device internal storage in bps.
     * e.g. 800000, 1600000, 4000000, 16000000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BANDWIDTH"] = 13] = "BANDWIDTH";
    /**
     * DEVICE_BRAND - The brand of the device mapped from the DEVICE_MODEL of the device.
     * e.g. Samsung, Huawei, Sony
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_BRAND"] = 14] = "DEVICE_BRAND";
    /**
     * IS_EMPLOYEE - Returns true when the user of the request is marked as an employee in Atlas.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_EMPLOYEE"] = 15] = "IS_EMPLOYEE";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USERNAME"] = 16] = "USERNAME";
    /**
     * IS_TEST_USER - Returns true when the user of the request is marked as a test user in Atlas.
     * e.g. TRUE/FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_TEST_USER"] = 17] = "IS_TEST_USER";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_PROFILE"] = 18] = "USER_PROFILE";
    /**
     * SCREEN_WIDTH - The width of screen resolution in pixels
     * e.g. 1024
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SCREEN_WIDTH"] = 19] = "SCREEN_WIDTH";
    /**
     * SCREEN_HEIGHT - The height of screen resolution in pixels
     * e.g. 1920
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SCREEN_HEIGHT"] = 20] = "SCREEN_HEIGHT";
    /**
     * HEVC_SUPPORT - Whether the device support HEVC
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HEVC_SUPPORT"] = 21] = "HEVC_SUPPORT";
    /**
     * DISK_SIZE - Total size of the device internal storage in MB
     * e.g. 1000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DISK_SIZE"] = 22] = "DISK_SIZE";
    /**
     * DISK_AVAILABLE - Available device internal storage in MB.
     * e.g. 1000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DISK_AVAILABLE"] = 23] = "DISK_AVAILABLE";
    /**
     * NETWORK_TYPE - Type of network the user is currently using when the request is handled by our service.
     * This property is evaluated on the server and will not change between sync calls.
     * e.g. CELLULAR, WIFI
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NETWORK_TYPE"] = 24] = "NETWORK_TYPE";
    /**
     * MAX_VIDEO_WIDTH - The maximum playable video width (assumes portrait orientation) in pixels
     * e.g. 1024
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MAX_VIDEO_WIDTH"] = 25] = "MAX_VIDEO_WIDTH";
    /**
     * MAX_VIDEO_HEIGHT - The maximum playable video height (assumes portrait orientation) in pixels
     * e.g. 1920
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MAX_VIDEO_HEIGHT"] = 26] = "MAX_VIDEO_HEIGHT";
    /**
     * MEDIA_TYPE_DEPRECATED - Type of media currently being processed.
     * e.g. IMAGE, VIDEO, GIF, AUDIO
     *
     * @deprecated
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MEDIA_TYPE_DEPRECATED"] = 27] = "MEDIA_TYPE_DEPRECATED";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_PUBLIC_STORY"] = 28] = "IS_PUBLIC_STORY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_OFFICIAL_STORY"] = 29] = "IS_OFFICIAL_STORY";
    /**
     * IS_NETWORK_METERED - Returns true when the network is metered at the time of the request.
     * This will not change between sync calls.
     * e.g. TRUE/FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_NETWORK_METERED"] = 30] = "IS_NETWORK_METERED";
    /**
     * IS_ROAMING - Returns true when the network is metered at the time of the request.
     * This property is evaluated on the server and will not change in value between sync calls.
     * e.g. TRUE/FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_ROAMING"] = 31] = "IS_ROAMING";
    /**
     * APP_ENGAGEMENT_LEVEL - Overall engagement with the app. Based on app_open_count
     * See definitions of engagement level properties here:
     * https://docs.google.com/document/d/1goLlXMdDGXN0B3zER_dPhl9vFk_TIjeNCqQb4zIQyBM/edit?pli=1
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_ENGAGEMENT_LEVEL"] = 32] = "APP_ENGAGEMENT_LEVEL";
    /**
     * COMMUNICATION_ENGAGEMENT_LEVEL - Users engagement with the chat. Based on send direct snap or chat engagement level
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["COMMUNICATION_ENGAGEMENT_LEVEL"] = 33] = "COMMUNICATION_ENGAGEMENT_LEVEL";
    /**
     * FRIEND_STORY_ENGAGEMENT_LEVEL - Users engagement with their friends stories.
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FRIEND_STORY_ENGAGEMENT_LEVEL"] = 34] = "FRIEND_STORY_ENGAGEMENT_LEVEL";
    /**
     * PUBLIC_USER_STORY_ENGAGEMENT_LEVEL - Public user story view engagement level
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["PUBLIC_USER_STORY_ENGAGEMENT_LEVEL"] = 35] = "PUBLIC_USER_STORY_ENGAGEMENT_LEVEL";
    /**
     * PUBLISHER_STORY_ENGAGEMENT_LEVEL - Publisher story view engagement level
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["PUBLISHER_STORY_ENGAGEMENT_LEVEL"] = 36] = "PUBLISHER_STORY_ENGAGEMENT_LEVEL";
    /**
     * LENS_ENGAGEMENT_LEVEL - Lens engagement level based on number of lens swipes a user has
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_ENGAGEMENT_LEVEL"] = 37] = "LENS_ENGAGEMENT_LEVEL";
    /**
     * CAMERA_CONTEXT - The context the user has opened the camera from.
     * This is a realtme property that evaluated on each use and requires CameraProvided signals for evaluation.
     * e.g. MAIN, REPLY, PROFILE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA_CONTEXT"] = 38] = "CAMERA_CONTEXT";
    /**
     * CAMERA_DIRECTION - The direction of the camera.
     * This is a realtme property that evaluated on each use and requires CameraProvided signals for evaluation.
     * e.g. FRONT, BACK
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA_DIRECTION"] = 39] = "CAMERA_DIRECTION";
    /**
     * CAMERA_FLASH_STATE - The current state of the flash when a Snap was captured.
     * This is a realtme property that evaluated on each use and requires CameraProvided signals for evaluation.
     * e.g. OFF, ON
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA_FLASH_STATE"] = 40] = "CAMERA_FLASH_STATE";
    /**
     * CAMERA_API - The current camera API stack that is being used on the device.
     * This is a realtme property that evaluated on each use and requires CameraProvided signals for evaluation.
     * e.g. CAMERA_1, CAMERA_2, ARCORE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA_API"] = 41] = "CAMERA_API";
    /**
     * NON_FRIEND_STORY_ENGAGEMENT_LEVEL - Non-friend story (public + publisher) view engagement level
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NON_FRIEND_STORY_ENGAGEMENT_LEVEL"] = 42] = "NON_FRIEND_STORY_ENGAGEMENT_LEVEL";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FOLLOWER_SIZE_LEVEL"] = 43] = "FOLLOWER_SIZE_LEVEL";
    /**
     * LEGACY_MUSHROOM_CONTENT_TYPE - The legacy content type that is being used in content manager.
     * See LegacyMushroomContent type for values:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/master/proto/cdp/cof/content_manager_provided_signals.proto
     * e.g. AD_SNAP, SNAP, STORY_SNAP, LENS_ICON, .....
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LEGACY_MUSHROOM_CONTENT_TYPE"] = 44] = "LEGACY_MUSHROOM_CONTENT_TYPE";
    /**
     * SNAP_SOURCE - The source of the snap that was captured. Required feature_provided signals to be evaluated.
     * Definition is snapchat.cdp.media.SnapSource
     * e.g. CAMERA, CAMERA_ROLL, GALLERY, IN_CHAT
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAP_SOURCE"] = 45] = "SNAP_SOURCE";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["UPLOAD_BANDWIDTH"] = 46] = "UPLOAD_BANDWIDTH";
    /**
     * DAYS_SINCE_CREATION - The number of days since this users account was created.
     * This is useful for rules that you only want to apply to new or old users.
     * e.g. [0..MAX_INT]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_CREATION"] = 47] = "DAYS_SINCE_CREATION";
    /**
     * CAMERA2_LEVEL - The Camera2 API support level of the device.
     * This is a realtime property that evaluated on each use and requires CameraProvided signals for evaluation.
     * e.g. LEGACY, LIMITED, FULL, LEVEL_3
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA2_LEVEL"] = 48] = "CAMERA2_LEVEL";
    /**
     * CAMERA_NIGHT_MODE_STATE - The night mode state of the camera.
     * This is a realtme property that evaluated on each use and requires CameraProvided signals for evaluation.
     * e.g. ON, OFF
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA_NIGHT_MODE_STATE"] = 49] = "CAMERA_NIGHT_MODE_STATE";
    /** USER_PERSONA - Persona of the user */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_PERSONA"] = 50] = "USER_PERSONA";
    /** USER_LANGUAGE - Language used by user. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_LANGUAGE"] = 51] = "USER_LANGUAGE";
    /**
     * USER_CREATION_TIME - The unix epoch time at which the user was created.
     * This is useful if you want to lock a cohort of users created at the same time for cohort testing.
     * e.g. unix_epoch time
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_CREATION_TIME"] = 52] = "USER_CREATION_TIME";
    /**
     * VIDEO_DURATION - The duration of a video in ms. This requires a feature provided signal to be passed
     * e.g. 6870, 1001
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["VIDEO_DURATION"] = 53] = "VIDEO_DURATION";
    /** MOBILE_NETWORK_TYPE - Deprecated */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MOBILE_NETWORK_TYPE"] = 54] = "MOBILE_NETWORK_TYPE";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["AGGREGATED_USER_BANDWIDTH"] = 55] = "AGGREGATED_USER_BANDWIDTH";
    /**
     * REALTIME_MOBILE_NETWORK_GENERATION - The type of mobile network the user is on.
     * This is evaluated in realtime by CirumsstanceEngine.
     * e.g. 3G, 4G, 5G
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["REALTIME_MOBILE_NETWORK_GENERATION"] = 56] = "REALTIME_MOBILE_NETWORK_GENERATION";
    /**
     * REALTIME_NETWORK_TYPE - The type network the user is on.
     * This is evaluated in realtime by CirumsstanceEngine.
     * e.g. WiFi, WWAN
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["REALTIME_NETWORK_TYPE"] = 57] = "REALTIME_NETWORK_TYPE";
    /**
     * REALTIME_NETWORK_IS_METERED - If the network is currently a metered connection.
     * This is evaluated in realtime by CirumsstanceEngine.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["REALTIME_NETWORK_IS_METERED"] = 58] = "REALTIME_NETWORK_IS_METERED";
    /**
     * REALTIME_NETWORK_IS_ROAMING - Tells if the current network connection is roaming.
     * This is evaluated in realtime by CirumsstanceEngine.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["REALTIME_NETWORK_IS_ROAMING"] = 59] = "REALTIME_NETWORK_IS_ROAMING";
    /**
     * LENS_CLUSTER_BIASED - The lens cluster of the device based on the biased algorithm.
     * e.g. [-1..6]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_CLUSTER_BIASED"] = 60] = "LENS_CLUSTER_BIASED";
    /**
     * LENS_CLUSTER_LOG - The lens cluster of the device based on a log distribution
     * e.g. [-1..6]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_CLUSTER_LOG"] = 61] = "LENS_CLUSTER_LOG";
    /**
     * LENS_CLUSTER_ORIG - The lens cluster of the device based on a normal distribution
     * e.g. [-1..6]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_CLUSTER_ORIG"] = 62] = "LENS_CLUSTER_ORIG";
    /**
     * LENS_CLUSTER_ORIG_4 - The lens cluster of the device based on a normal distribution
     * e.g. [-1..4]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_CLUSTER_ORIG_4"] = 63] = "LENS_CLUSTER_ORIG_4";
    /**
     * LENS_CLUSTER_BIASED_LOG - The lens cluster of the device based on a biased log distribution
     * e.g. [-1..6]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_CLUSTER_BIASED_LOG"] = 64] = "LENS_CLUSTER_BIASED_LOG";
    /**
     * APP_LOCALE - The Locale of that our app is currently using. This is a subset of the locales that the device may be in
     * e.g. en_us, en_gb, zh_cn
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_LOCALE"] = 65] = "APP_LOCALE";
    /**
     * DEVICE_COMMON_NAME - The common name of the device that is mapped from the DEVICE_MODEL
     * e.g. Galaxy S7, Galaxy S7 Edge, P20 Lite
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_COMMON_NAME"] = 66] = "DEVICE_COMMON_NAME";
    /**
     * PICTURE_MODE - The mode in which the camera will return images from the takepicture command.
     * This requires FeaatureProvidedSignals for evaluation
     * e.g. GPU, JPEG
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["PICTURE_MODE"] = 67] = "PICTURE_MODE";
    /**
     * USER_FRIEND_COUNT - The number of friends a user has.
     * e.g. [0 .. 5000]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_FRIEND_COUNT"] = 68] = "USER_FRIEND_COUNT";
    /**
     * BOLT_USE_CASE - The current usecase of the request to BOLT, this requires feature provided signals
     * e.g. int values
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BOLT_USE_CASE"] = 69] = "BOLT_USE_CASE";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["L90_COUNTRY"] = 70] = "L90_COUNTRY";
    /** STUB - Deprecated */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STUB"] = 71] = "STUB";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_TRUE"] = 72] = "IS_TRUE";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STORY_POST_RATIO"] = 73] = "STORY_POST_RATIO";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GENDER"] = 74] = "GENDER";
    /** INFERRED_AGE_BUCKET - Inferred age bucket of the user */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["INFERRED_AGE_BUCKET"] = 75] = "INFERRED_AGE_BUCKET";
    /** STORIES - Number of posted stories in the last 7 days */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STORIES"] = 76] = "STORIES";
    /** SENDS - Total number of send snaps plus number of posted stories in the last 7 days */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SENDS"] = 77] = "SENDS";
    /** SNAP_CREATE_L7 - L7 level for snap creation engagements */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAP_CREATE_L7"] = 78] = "SNAP_CREATE_L7";
    /** STORY_POST_L7 - L7 level for story post engagements */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STORY_POST_L7"] = 79] = "STORY_POST_L7";
    /** COMMUNICATION_L7 - L7 level for communication engagements */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["COMMUNICATION_L7"] = 80] = "COMMUNICATION_L7";
    /** DF_L7 - L7 level for discover feed engagements */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DF_L7"] = 81] = "DF_L7";
    /** APP_L7 - L7 level for app engagements */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_L7"] = 82] = "APP_L7";
    /** DAYS_SINCE_CREATION_BUCKET - Bucket for days since creation. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_CREATION_BUCKET"] = 83] = "DAYS_SINCE_CREATION_BUCKET";
    /** BIDIRECTIONAL_FRIEND_STATUS - bucket for number of bidirectional friends. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BIDIRECTIONAL_FRIEND_STATUS"] = 84] = "BIDIRECTIONAL_FRIEND_STATUS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STORY_POST_PREDICTION"] = 85] = "STORY_POST_PREDICTION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BOLT_CDN_EXPERIMENTATION_ID"] = 86] = "BOLT_CDN_EXPERIMENTATION_ID";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MINS_SINCE_LAST_LENS_ACTIVATION"] = 87] = "MINS_SINCE_LAST_LENS_ACTIVATION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPENS"] = 88] = "APP_OPENS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_SWIPES"] = 89] = "LENS_SWIPES";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_SNAPS"] = 90] = "LENS_SNAPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_OPS"] = 91] = "LENS_OPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W1_APP_OPENS"] = 92] = "W1_APP_OPENS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W1_LENS_SWIPES"] = 93] = "W1_LENS_SWIPES";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W1_LENS_SNAPS"] = 94] = "W1_LENS_SNAPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W1_LENS_OPS"] = 95] = "W1_LENS_OPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W2_APP_OPENS"] = 96] = "W2_APP_OPENS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W2_LENS_SWIPES"] = 97] = "W2_LENS_SWIPES";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W2_LENS_SNAPS"] = 98] = "W2_LENS_SNAPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W2_LENS_OPS"] = 99] = "W2_LENS_OPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W34_APP_OPENS"] = 100] = "W34_APP_OPENS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W34_LENS_SWIPES"] = 101] = "W34_LENS_SWIPES";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W34_LENS_SNAPS"] = 102] = "W34_LENS_SNAPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["W34_LENS_OPS"] = 103] = "W34_LENS_OPS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENS_SWIPES_PREDICTION"] = 104] = "LENS_SWIPES_PREDICTION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["REGISTRATION_COUNTRY"] = 105] = "REGISTRATION_COUNTRY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IP_ASN"] = 106] = "IP_ASN";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IP_REGION"] = 107] = "IP_REGION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IP_CITY"] = 108] = "IP_CITY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_USER_ID"] = 109] = "HAS_USER_ID";
    /**
     * HAS_BITMOJI - Whether a user has bitmoji
     * e.g. TRUE, FALSE.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_BITMOJI"] = 110] = "HAS_BITMOJI";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NUM_APP_OPENS_LAST_8_DAYS"] = 111] = "NUM_APP_OPENS_LAST_8_DAYS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MINS_SINCE_LAST_SNAPPABLE_LENS_ACTIVATION"] = 112] = "MINS_SINCE_LAST_SNAPPABLE_LENS_ACTIVATION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NUM_FEATURE_STORY_VIEW_DAYS_L7"] = 113] = "NUM_FEATURE_STORY_VIEW_DAYS_L7";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NUM_FEATURE_STORY_SYNC_DAYS_L7"] = 114] = "NUM_FEATURE_STORY_SYNC_DAYS_L7";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HEXAGON_NN_SUPPORTED_VERSION"] = 115] = "HEXAGON_NN_SUPPORTED_VERSION";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_LAST_LOGIN_OR_OPEN"] = 116] = "DAYS_SINCE_LAST_LOGIN_OR_OPEN";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SPECTACLES_VERSION"] = 117] = "SPECTACLES_VERSION";
    /** NETWORK_QUALITY - Quality of the network. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NETWORK_QUALITY"] = 118] = "NETWORK_QUALITY";
    /**
     * DEVICE_MEMORY_MB - Device memory in MB.
     * e.g. 4000, 8000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_MEMORY_MB"] = 119] = "DEVICE_MEMORY_MB";
    /**
     * DEVICE_GL_VERSION - Device OpenGL version, value as (major * 100 + minor). Example: 3.2 is reported as 302
     * e.g. 302, 301
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_GL_VERSION"] = 120] = "DEVICE_GL_VERSION";
    /** SNAP_PRO_STATUS - Snap pro status of the user. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAP_PRO_STATUS"] = 121] = "SNAP_PRO_STATUS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_VP9_DECODING_SUPPORT"] = 122] = "DEVICE_VP9_DECODING_SUPPORT";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["AVG_FRIEND_STORY_VIEW_COUNT_L7"] = 123] = "AVG_FRIEND_STORY_VIEW_COUNT_L7";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GAME_JOIN_TIME"] = 124] = "GAME_JOIN_TIME";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GAME_LAST_ACTIVE_TIME"] = 125] = "GAME_LAST_ACTIVE_TIME";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_FIRST_GAME_ACTIVITY"] = 126] = "DAYS_SINCE_FIRST_GAME_ACTIVITY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_LAST_GAME_ACTIVITY"] = 127] = "DAYS_SINCE_LAST_GAME_ACTIVITY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["PF_PAGE_SESSIONS_WITH_LONG_IMP"] = 128] = "PF_PAGE_SESSIONS_WITH_LONG_IMP";
    /**
     * STICKY_MAX_CONNECTION_TYPE - Client side property that is based on the fastest connection type that the device has used in the last week. On the client, the device updates and persists the network type in use with a timestamp. During retrieval that data is used to determine the fastest connection type that was used within the last week.
     * e.g. 4G, 5G
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STICKY_MAX_CONNECTION_TYPE"] = 129] = "STICKY_MAX_CONNECTION_TYPE";
    /**
     * WIRELESS_CARRIER - Server side property that is evaluated based based on the wireless carrier that the device has during sync.
     * e.g. GoogleFi, Verizon ...
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["WIRELESS_CARRIER"] = 130] = "WIRELESS_CARRIER";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["WITH_ANIMATED_OVERLAY"] = 131] = "WITH_ANIMATED_OVERLAY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MINIS_JOIN_TIME"] = 132] = "MINIS_JOIN_TIME";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MINIS_LAST_ACTIVE_TIME"] = 133] = "MINIS_LAST_ACTIVE_TIME";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_FIRST_MINIS_ACTIVITY"] = 134] = "DAYS_SINCE_FIRST_MINIS_ACTIVITY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_LAST_MINIS_ACTIVITY"] = 135] = "DAYS_SINCE_LAST_MINIS_ACTIVITY";
    /**
     * DEVICE_AV1_DECODING_SUPPORT - Server side property that is built from codec benchmarks to determine if a device supports av1
     * e.g. SOFTWARE, HARDWARE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DEVICE_AV1_DECODING_SUPPORT"] = 136] = "DEVICE_AV1_DECODING_SUPPORT";
    /**
     * APP_PACKAGE_INSTALLER - Server side property that targets how an app was installed. This data is provided in the targetingQuery request.
     * e.g. com.android.vending, com.google.android.packageinstaller, com.lenovo.anyshare.gps, com.huawei.appmarket, cn.xender
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_PACKAGE_INSTALLER"] = 137] = "APP_PACKAGE_INSTALLER";
    /** URL - A client-determined URL */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["URL"] = 138] = "URL";
    /**
     * ESTIMATED_DURATION_FOR_EVENT_MS - The estimated duration for a config-specific event in milliseconds
     * For example, for a config that chooses upload location, use the estimated time to upload a file
     * e.g. 100
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ESTIMATED_DURATION_FOR_EVENT_MS"] = 139] = "ESTIMATED_DURATION_FOR_EVENT_MS";
    /**
     * MEDIA_SOURCE - Content's origin prior to being injected into the MDP stack.
     * e.g. CHAT, MEMORIES, LENS, MAPS
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MEDIA_SOURCE"] = 140] = "MEDIA_SOURCE";
    /**
     * ASSET_TYPE - How to compose an individual asset into one larger logical asset.
     * e.g. BLOOPS_STICKER, MUSIC, RAW_MEDIA, CANVAS_STICKER, etc.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ASSET_TYPE"] = 141] = "ASSET_TYPE";
    /**
     * STORY_VIEWS_5TH_TAB_ENGAGEMENT_LEVEL - This is based on percentile of number of story views in 5th tab user falls into
     * [-1 (unknown), 0 (no views), 1 (casual: view=1), 2 (regular: view=[2,3]), 3 (power: view>=4)]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["STORY_VIEWS_5TH_TAB_ENGAGEMENT_LEVEL"] = 142] = "STORY_VIEWS_5TH_TAB_ENGAGEMENT_LEVEL";
    /**
     * REPORTED_AGE - This age based on user reported birthday.
     * e.g. 18
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["REPORTED_AGE"] = 143] = "REPORTED_AGE";
    /**
     * ANDROID_MOBILE_SERVICES_PROVIDER - Android has multiple sources of mobile services which provide functionality like GPS and Firebase APIs.
     * e.g. GMS, HMS
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ANDROID_MOBILE_SERVICES_PROVIDER"] = 144] = "ANDROID_MOBILE_SERVICES_PROVIDER";
    /** IS_ACQUIRED_USER - true if the user comes from a paid channel */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_ACQUIRED_USER"] = 145] = "IS_ACQUIRED_USER";
    /** YDPI - Physical pixels per inch of the screen in the Y dimension e.g. 440 */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["YDPI"] = 146] = "YDPI";
    /** BOLT_IS_CONTENT_POPULAR - A boolean representing whether the content being resolved is popular or not. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BOLT_IS_CONTENT_POPULAR"] = 147] = "BOLT_IS_CONTENT_POPULAR";
    /** CAPTURE_MODE - e.g. Default, Timeline */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAPTURE_MODE"] = 148] = "CAPTURE_MODE";
    /**
     * BIDIRECTIONAL_FRIEND_STATUS_VELLUM - This new breakdown is the same as what has been used for husky runbook
     * e.g. '0-5', '6-30', etc
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BIDIRECTIONAL_FRIEND_STATUS_VELLUM"] = 149] = "BIDIRECTIONAL_FRIEND_STATUS_VELLUM";
    /** ORIGIN - Origin or “application name” of user agent. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ORIGIN"] = 150] = "ORIGIN";
    /** LENSCORE_VERSION - Lens core version which will be passed by all clients */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LENSCORE_VERSION"] = 151] = "LENSCORE_VERSION";
    /** SNAPKIT_APP_ID - SnapKit app id from SnapKit Dev Portal */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAPKIT_APP_ID"] = 152] = "SNAPKIT_APP_ID";
    /** GPU - gpu as string e.g. Adreno 650 */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GPU"] = 153] = "GPU";
    /** CHIPSET_NAME - Chipset name as string  e.g. Qualcomm Snapdragon */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CHIPSET_NAME"] = 154] = "CHIPSET_NAME";
    /** CHIPSET_VERSION - Chipset version as int  e.g. 865 */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CHIPSET_VERSION"] = 155] = "CHIPSET_VERSION";
    /** HAS_ZERO_IDFA - True if user has a zero-ed out IDFA */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_ZERO_IDFA"] = 156] = "HAS_ZERO_IDFA";
    /** LIMIT_AD_TRACKING - True if user has limit ad tracking enabled */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LIMIT_AD_TRACKING"] = 157] = "LIMIT_AD_TRACKING";
    /**
     * ATT_AUTH_STATUS - Users app tracking transparency authentication status
     * values = [RESTRICTED, NOT_DETERMINED, DENIED, AUTHORIZED]
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ATT_AUTH_STATUS"] = 158] = "ATT_AUTH_STATUS";
    /** VP9_SOFTWARE_DECODING_SUPPORTED - A boolean representing if VP9 software decoding is supported */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["VP9_SOFTWARE_DECODING_SUPPORTED"] = 159] = "VP9_SOFTWARE_DECODING_SUPPORTED";
    /** AV1_SOFTWARE_DECODING_SUPPORTED - A boolean representing if AV1 software decoding is supported */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["AV1_SOFTWARE_DECODING_SUPPORTED"] = 160] = "AV1_SOFTWARE_DECODING_SUPPORTED";
    /** WITH_MUSIC - A boolean to indicate whether there is music edits (e.g. music sticker). */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["WITH_MUSIC"] = 161] = "WITH_MUSIC";
    /** CAMERA2_FRONT_SS_GAIN_OVER_TPA - An integer for front camera2. 100 * (snap send image using screenshot - snap send image using TPA) / snap send image using TPA */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA2_FRONT_SS_GAIN_OVER_TPA"] = 162] = "CAMERA2_FRONT_SS_GAIN_OVER_TPA";
    /** ATTACHMENT_TOOL_V2 - A boolean to indicate whether attachment tool v2 is enabled for this user. True is enabled */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ATTACHMENT_TOOL_V2"] = 163] = "ATTACHMENT_TOOL_V2";
    /**
     * MEDIA_TYPE - Type of media currently being processed.
     * e.g. IMAGE, VIDEO, GIF, AUDIO
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MEDIA_TYPE"] = 164] = "MEDIA_TYPE";
    /**
     * USER_PERSONA_V3 - User persona V3 defined in https://github.sc-corp.net/Snapchat/ab-test-console/blob/master/CircumstancesCMS/circumstances-proto/src/main/proto/user_property.proto
     * e.g. STORY_POSTER_V3, MAPPER_V3, CAMERA_LOVER_V3
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_PERSONA_V3"] = 165] = "USER_PERSONA_V3";
    /**
     * FEATURE_PROVIDED_SIZE - A client provided integer representing size. The units is decided by the caller.
     * This will be evaluated using FeatureProvidedSignals.size
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FEATURE_PROVIDED_SIZE"] = 166] = "FEATURE_PROVIDED_SIZE";
    /**
     * SNAPS_SEND_WITH_HEVC - An Int property showing the number of snaps the user sent in last 7 days, which the receivers had HEVC support.
     * The receiver HEVC support is defined by min of HEVC support, if multiple devices are used in the last 7 days.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAPS_SEND_WITH_HEVC"] = 167] = "SNAPS_SEND_WITH_HEVC";
    /**
     * SNAPS_SEND_WITHOUT_HEVC - An Int property showing the number of snaps the user sent in last 7 days, which the receivers did nor have HEVC support.
     * The receiver HEVC support is defined by min of HEVC support, if multiple devices are used in the last 7 days.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAPS_SEND_WITHOUT_HEVC"] = 168] = "SNAPS_SEND_WITHOUT_HEVC";
    /** CAMERA2_NATIVE_CRASH_OVER_CAMERA1 - An integer value. 100 * (camera 2 native crash rate - camera 1 native crash rate) / camera 1 native crash rate */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA2_NATIVE_CRASH_OVER_CAMERA1"] = 169] = "CAMERA2_NATIVE_CRASH_OVER_CAMERA1";
    /** CAMERA2_G2S_LATENCY_OVER_CAMERA1 - An integer value. 100 * (camera 2 G2S latency - camera 1 G2S latency) / camera 1 G2S latencyTargetingExpressionValidator.java */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMERA2_G2S_LATENCY_OVER_CAMERA1"] = 170] = "CAMERA2_G2S_LATENCY_OVER_CAMERA1";
    /** SCANNED_CATEGORY_IDS - The ids of the categories that are currently being scanned for (e.g. Amazon, Photomath, etc) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SCANNED_CATEGORY_IDS"] = 171] = "SCANNED_CATEGORY_IDS";
    /**
     * CONTENT_VIEW_SOURCE - ContentViewSource (mirrored from Blizzard enum) which identified Opera session
     * e.g. DF_FRIENDS, NYC, DF_FOR_YOU.  See https://github.sc-corp.net/Snapchat/snapchat/blob/master/blizzard/schema/blizzard-schema/codeGen/src/main/java/com/snapchat/analytics/schema/events/ContentViewSource.java
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CONTENT_VIEW_SOURCE"] = 172] = "CONTENT_VIEW_SOURCE";
    /**
     * IS_INTERNAL - A combination of the IS_EMPLOYEE, IS_TEST_USER, and BUILD_FLAVOR for internal builds
     * Used to align INTERNAL status of configs with develop mode of AB studies
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_INTERNAL"] = 173] = "IS_INTERNAL";
    /** IS_WEB - A boolean to indicate whether there is web browser request */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_WEB"] = 174] = "IS_WEB";
    /** RECIPIENTS_SUPPORT_HEVC - A boolean indicating whether a group of recipients support High Efficiency Video Encoding (HEVC) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["RECIPIENTS_SUPPORT_HEVC"] = 175] = "RECIPIENTS_SUPPORT_HEVC";
    /**
     * APP_OPEN_TO_MAP - Probabilty [0,100] of a user going to X page after oppening the app
     * X IN (map, lenses, friendfeeds, memories, community, spotlight) pages
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPEN_TO_MAP"] = 176] = "APP_OPEN_TO_MAP";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPEN_TO_FRIENDSFEED"] = 177] = "APP_OPEN_TO_FRIENDSFEED";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPEN_TO_LENSES"] = 178] = "APP_OPEN_TO_LENSES";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPEN_TO_MEMORIES"] = 179] = "APP_OPEN_TO_MEMORIES";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPEN_TO_COMMUNITY"] = 180] = "APP_OPEN_TO_COMMUNITY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_OPEN_TO_SPOTLIGHT"] = 181] = "APP_OPEN_TO_SPOTLIGHT";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_IMPACTED_BY_PINC_893"] = 182] = "IS_IMPACTED_BY_PINC_893";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_BEFORE_BIRTHDAY"] = 183] = "DAYS_BEFORE_BIRTHDAY";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_BIPA"] = 184] = "HAS_BIPA";
    /** EMAIL_VERIFIED - Whether user's email has verified */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["EMAIL_VERIFIED"] = 185] = "EMAIL_VERIFIED";
    /** PHONE_VERIFIED - Whether user's phone number has verified */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["PHONE_VERIFIED"] = 186] = "PHONE_VERIFIED";
    /** NOTIFICATION_PERM_GRANTED - Whether notification permission has granted */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NOTIFICATION_PERM_GRANTED"] = 187] = "NOTIFICATION_PERM_GRANTED";
    /** CONTACT_PERM_GRANTED - Whether contact permission has granted */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CONTACT_PERM_GRANTED"] = 188] = "CONTACT_PERM_GRANTED";
    /** MUTUAL_FRIENDS_COUNT - Mutual friends count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MUTUAL_FRIENDS_COUNT"] = 189] = "MUTUAL_FRIENDS_COUNT";
    /** GROUPS_COUNT - Groups count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GROUPS_COUNT"] = 190] = "GROUPS_COUNT";
    /** SPOTLIGHT_STORY_ENGAGEMENT_STATUS - Spotlight user cohort */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SPOTLIGHT_STORY_ENGAGEMENT_STATUS"] = 191] = "SPOTLIGHT_STORY_ENGAGEMENT_STATUS";
    /** HAS_NON_TEAM_SNAPCHAT_CONVERSATIONS - Whether user has non-team snapchat conversations */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_NON_TEAM_SNAPCHAT_CONVERSATIONS"] = 192] = "HAS_NON_TEAM_SNAPCHAT_CONVERSATIONS";
    /** COGNAC_APP_ID - A Cognac game/mini id that a user is playing */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["COGNAC_APP_ID"] = 193] = "COGNAC_APP_ID";
    /** PLAYBACK_ITEM_TYPE - Opera playback item type */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["PLAYBACK_ITEM_TYPE"] = 194] = "PLAYBACK_ITEM_TYPE";
    /**
     * SUP_IS_BIRTHDAY_PARTY_ENABLED - SUP's birthday party enabled:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/3554d12/proto/sup/sup.proto#L87
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_IS_BIRTHDAY_PARTY_ENABLED"] = 195] = "SUP_IS_BIRTHDAY_PARTY_ENABLED";
    /**
     * SUP_FHP_LAST_INTERACTION_TIME_MILLIS_TO_NOW - SUP's fhp last interaction time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L990
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_LAST_INTERACTION_TIME_MILLIS_TO_NOW"] = 196] = "SUP_FHP_LAST_INTERACTION_TIME_MILLIS_TO_NOW";
    /**
     * SUP_FHP_CONTACT_SYNC_INTERACTION_COUNT - SUP's fhp contact sync interaction count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L992
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_CONTACT_SYNC_INTERACTION_COUNT"] = 197] = "SUP_FHP_CONTACT_SYNC_INTERACTION_COUNT";
    /**
     * SUP_FHP_CONTACT_SYNC_LAST_SHOWN_TIME_MILLIS_TO_NOW - SUP's fhp contact sync prompt first shown time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L994
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_CONTACT_SYNC_LAST_SHOWN_TIME_MILLIS_TO_NOW"] = 198] = "SUP_FHP_CONTACT_SYNC_LAST_SHOWN_TIME_MILLIS_TO_NOW";
    /**
     * SUP_FHP_NOTIFICATION_PERMISSION_INTERACTION_COUNT - SUP's fhp notification permission prompt interaction counter, including dismisses and clicks:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L996
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_NOTIFICATION_PERMISSION_INTERACTION_COUNT"] = 199] = "SUP_FHP_NOTIFICATION_PERMISSION_INTERACTION_COUNT";
    /**
     * SUP_FHP_NOTIFICATION_PERMISSION_LAST_SHOWN_TIME_MILLIS_TO_NOW - SUP's fhp notification permission prompt first shown time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L998
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_NOTIFICATION_PERMISSION_LAST_SHOWN_TIME_MILLIS_TO_NOW"] = 200] = "SUP_FHP_NOTIFICATION_PERMISSION_LAST_SHOWN_TIME_MILLIS_TO_NOW";
    /**
     * SUP_FHP_PHONE_VERIFICATION_INTERACTION_COUNT - SUP's fhp phone verification prompt interaction counter, including dismisses and clicks:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_PHONE_VERIFICATION_INTERACTION_COUNT"] = 201] = "SUP_FHP_PHONE_VERIFICATION_INTERACTION_COUNT";
    /**
     * SUP_FHP_PHONE_VERIFICATION_LAST_SHOWN_TIME_MILLIS_TO_NOW - SUP's fhp phone verification prompt first shown time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1002
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_PHONE_VERIFICATION_LAST_SHOWN_TIME_MILLIS_TO_NOW"] = 202] = "SUP_FHP_PHONE_VERIFICATION_LAST_SHOWN_TIME_MILLIS_TO_NOW";
    /**
     * SUP_FHP_BIRTHDAY_PARTY_INTERACTION_COUNT - SUP's fhp birthday party prompt interaction counter, including dismisses and clicks:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1004
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_BIRTHDAY_PARTY_INTERACTION_COUNT"] = 203] = "SUP_FHP_BIRTHDAY_PARTY_INTERACTION_COUNT";
    /**
     * SUP_FHP_BIRTHDAY_PARTY_LAST_SHOWN_TIME_MILLIS_TO_NOW - SUP's fhp birthday party prompt first shown time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1006
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_BIRTHDAY_PARTY_LAST_SHOWN_TIME_MILLIS_TO_NOW"] = 204] = "SUP_FHP_BIRTHDAY_PARTY_LAST_SHOWN_TIME_MILLIS_TO_NOW";
    /**
     * SUP_FHP_EMAIL_VERIFICATION_INTERACTION_COUNT - SUP's fhp email verification prompt interaction counter, including dismisses and clicks:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1008
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_EMAIL_VERIFICATION_INTERACTION_COUNT"] = 205] = "SUP_FHP_EMAIL_VERIFICATION_INTERACTION_COUNT";
    /**
     * SUP_FHP_EMAIL_VERIFICATION_LAST_SHOWN_TIME_MILLIS_TO_NOW - SUP's fhp email verification prompt first shown time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1010
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_EMAIL_VERIFICATION_LAST_SHOWN_TIME_MILLIS_TO_NOW"] = 206] = "SUP_FHP_EMAIL_VERIFICATION_LAST_SHOWN_TIME_MILLIS_TO_NOW";
    /** HAS_USED_SPECTACLES - Whether the user has used Spectacles (incl. Cheerios) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_USED_SPECTACLES"] = 207] = "HAS_USED_SPECTACLES";
    /** BOLT_CLIENT_APP_STATE - Enum indicating client App State (Used by BOLT to create targeted network rules) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BOLT_CLIENT_APP_STATE"] = 208] = "BOLT_CLIENT_APP_STATE";
    /** EMAIL_SET - Whether user's email has been set (might or might not be verified) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["EMAIL_SET"] = 209] = "EMAIL_SET";
    /** BITMOJI_SET - Whether user's bitmoji has been set */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BITMOJI_SET"] = 210] = "BITMOJI_SET";
    /** QUICK_TAP_CAMERA_SUPPORTED_ENABLED - Quick tap on camera is supported and enabled */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["QUICK_TAP_CAMERA_SUPPORTED_ENABLED"] = 211] = "QUICK_TAP_CAMERA_SUPPORTED_ENABLED";
    /** HAS_ADD_FRIENDS_REQUEST - Whether user has add friends request */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_ADD_FRIENDS_REQUEST"] = 212] = "HAS_ADD_FRIENDS_REQUEST";
    /** APP_LAUNCH_FROM_PUSH - App launched from push notification */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_LAUNCH_FROM_PUSH"] = 213] = "APP_LAUNCH_FROM_PUSH";
    /** APP_LAUNCH_TYPE - App launch type: cold start, warm start, registration and login */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["APP_LAUNCH_TYPE"] = 214] = "APP_LAUNCH_TYPE";
    /** BILLBOARD_CAMPAIGN_LOCAL_IMPRESSION_COUNT - Billboard campaign level locally tracked impression count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_IMPRESSION_COUNT"] = 215] = "BILLBOARD_CAMPAIGN_LOCAL_IMPRESSION_COUNT";
    /** BILLBOARD_CAMPAIGN_LOCAL_LAST_IMPRESSION_TIME_SECS_TO_NOW - Billboard campaign level locally tracked last impression time in secs to now */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 216] = "BILLBOARD_CAMPAIGN_LOCAL_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /** BILLBOARD_CAMPAIGN_LOCAL_CONTINUOUS_DISMISS_COUNT - Billboard campaign level locally tracked continuous dismiss count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_CONTINUOUS_DISMISS_COUNT"] = 217] = "BILLBOARD_CAMPAIGN_LOCAL_CONTINUOUS_DISMISS_COUNT";
    /** FST_NUM_IN_APP_WARNINGS - FST number of in app warnings to show */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FST_NUM_IN_APP_WARNINGS"] = 218] = "FST_NUM_IN_APP_WARNINGS";
    /** FST_SHOULD_CHANGE_PASSWORD - FST user should change password */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FST_SHOULD_CHANGE_PASSWORD"] = 219] = "FST_SHOULD_CHANGE_PASSWORD";
    /** FST_IS_BACKGROUND_CHECK - Whether it's a background check or foreground check. Android specific */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FST_IS_BACKGROUND_CHECK"] = 220] = "FST_IS_BACKGROUND_CHECK";
    /**
     * SUP_FST_IDENTITY_VERIFICATION_IMPRESSION_COUNT - SUP's fst identity verification prompt impression count
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L648
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_IDENTITY_VERIFICATION_IMPRESSION_COUNT"] = 221] = "SUP_FST_IDENTITY_VERIFICATION_IMPRESSION_COUNT";
    /**
     * SUP_FST_IDENTITY_VERIFICATION_LAST_IMPRESSION_TIME_SECS_TO_NOW - SUP's fst identity verification prompt last impression time in secs to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L647
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_IDENTITY_VERIFICATION_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 222] = "SUP_FST_IDENTITY_VERIFICATION_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /**
     * SUP_FST_FRIEND_ADD_LAST_IMPRESSION_TIME_SECS_TO_NOW - SUP's fst friend reciprocation prompt last impression time in secs to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L482
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_FRIEND_ADD_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 223] = "SUP_FST_FRIEND_ADD_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /**
     * SUP_FST_CONTACT_SYNC_IMPRESSION_COUNT - SUP's fst contact sync impression count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L536
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_CONTACT_SYNC_IMPRESSION_COUNT"] = 224] = "SUP_FST_CONTACT_SYNC_IMPRESSION_COUNT";
    /**
     * SUP_FST_CONTACT_SYNC_LAST_IMPRESSION_TIME_SECS_TO_NOW - SUP's fst contact sync last impression time in secs to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L537
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_CONTACT_SYNC_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 225] = "SUP_FST_CONTACT_SYNC_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /**
     * SUP_FST_BITMOJI_CREATION_IMPRESSION_COUNT - SUP's fst bitmoji creation impression count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L841
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_BITMOJI_CREATION_IMPRESSION_COUNT"] = 226] = "SUP_FST_BITMOJI_CREATION_IMPRESSION_COUNT";
    /**
     * SUP_FST_BITMOJI_CREATION_LAST_IMPRESSION_TIME_SECS_TO_NOW - SUP's fst bitmoji creation last impression time in secs to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L828
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_BITMOJI_CREATION_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 227] = "SUP_FST_BITMOJI_CREATION_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /**
     * SUP_FST_USER_REACHABILITY_LAST_IMPRESSION_TIME_SECS_TO_NOW - SUP's fst user reachability last impression time in secs to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L986
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_USER_REACHABILITY_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 228] = "SUP_FST_USER_REACHABILITY_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /**
     * SUP_FST_BIPA_HAS_CLICKED - SUP's fst bipa has been accepted:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L908
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_BIPA_HAS_CLICKED"] = 229] = "SUP_FST_BIPA_HAS_CLICKED";
    /**
     * INCLUSION_PANEL_MEMBER - Flag to indicate that the user took part in the inclusion (Made for me) panel.
     * True if the user did, false otherwise.
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["INCLUSION_PANEL_MEMBER"] = 230] = "INCLUSION_PANEL_MEMBER";
    /** AUDIO_RECORD_PERM_GRANTED - Whether audio record permission has granted */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["AUDIO_RECORD_PERM_GRANTED"] = 231] = "AUDIO_RECORD_PERM_GRANTED";
    /** MUTUAL_FRIENDS_WITH_BIRTHDAY_COUNT - Mutual Friends with birthday count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MUTUAL_FRIENDS_WITH_BIRTHDAY_COUNT"] = 232] = "MUTUAL_FRIENDS_WITH_BIRTHDAY_COUNT";
    /** BILLBOARD_CAMPAIGN_LOCAL_DISMISS_COUNT - Billboard campaign level locally tracked dismiss count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_DISMISS_COUNT"] = 233] = "BILLBOARD_CAMPAIGN_LOCAL_DISMISS_COUNT";
    /**
     * SUP_PAC_PHONE_VERIFICATION_DISMISS_COUNT - SUP's pac phone verification dismiss count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L1092
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_PHONE_VERIFICATION_DISMISS_COUNT"] = 234] = "SUP_PAC_PHONE_VERIFICATION_DISMISS_COUNT";
    /**
     * SUP_PAC_BIRTHDAY_MINI_IMPRESSION_COUNT - SUP's pac birthday mini impression count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L754
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_BIRTHDAY_MINI_IMPRESSION_COUNT"] = 235] = "SUP_PAC_BIRTHDAY_MINI_IMPRESSION_COUNT";
    /**
     * SUP_PAC_BIRTHDAY_MINI_DISMISS_COUNT - SUP's pac birthday mini dismiss count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L1088
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_BIRTHDAY_MINI_DISMISS_COUNT"] = 236] = "SUP_PAC_BIRTHDAY_MINI_DISMISS_COUNT";
    /**
     * SUP_PAC_RUN_FOR_OFFICE_MINI_IMPRESSION_COUNT - SUP's pac run for office mini impression count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L760
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_RUN_FOR_OFFICE_MINI_IMPRESSION_COUNT"] = 237] = "SUP_PAC_RUN_FOR_OFFICE_MINI_IMPRESSION_COUNT";
    /**
     * SUP_PAC_RUN_FOR_OFFICE_MINI_DISMISS_COUNT - SUP's pac run for office mini dismiss count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L1090
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_RUN_FOR_OFFICE_MINI_DISMISS_COUNT"] = 238] = "SUP_PAC_RUN_FOR_OFFICE_MINI_DISMISS_COUNT";
    /**
     * SUP_PAC_FRIEND_CHECKUP_LAST_SHOWN_TIME_MILLIS_TO_NOW - SUP's pac friend checkup card was last shown in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L931
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_FRIEND_CHECKUP_LAST_SHOWN_TIME_MILLIS_TO_NOW"] = 239] = "SUP_PAC_FRIEND_CHECKUP_LAST_SHOWN_TIME_MILLIS_TO_NOW";
    /**
     * SUP_PAC_FRIEND_CHECKUP_IMPRESSION_COUNT - SUP's pac friend checkup card's impression count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L933
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_FRIEND_CHECKUP_IMPRESSION_COUNT"] = 240] = "SUP_PAC_FRIEND_CHECKUP_IMPRESSION_COUNT";
    /**
     * SUP_PAC_FRIEND_CHECKUP_CLICK_COUNT - SUP's friend checkup card's click count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L935
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_FRIEND_CHECKUP_CLICK_COUNT"] = 241] = "SUP_PAC_FRIEND_CHECKUP_CLICK_COUNT";
    /**
     * SUP_PAC_FRIEND_CHECKUP_DISMISS_COUNT - SUP's friend checkup card's dismiss count:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/34ca2a6/proto/sup/sup.proto#L937
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_FRIEND_CHECKUP_DISMISS_COUNT"] = 242] = "SUP_PAC_FRIEND_CHECKUP_DISMISS_COUNT";
    /** USE_VERTICAL_NAVIGATION - A boolean to indicate whether Opera uses vertical navigation or not. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USE_VERTICAL_NAVIGATION"] = 243] = "USE_VERTICAL_NAVIGATION";
    /**
     * HEVC_HW_DECODER - Whether a device supports HEVC decoding using hardware and what max resolution width it should support
     * e.g. 720, 540, 1080
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HEVC_HW_DECODER"] = 244] = "HEVC_HW_DECODER";
    /**
     * HEVC_SW_DECODER - Whether a device supports HEVC decoding using hardware/software and what max resolution width it should support
     * e.g. 720, 540, 1080
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HEVC_SW_DECODER"] = 245] = "HEVC_SW_DECODER";
    /**
     * SUP_FHP_CONTACT_SYNC_IMPRESSION_COUNT - SUP's FHP contact sync prompt impression counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/fc53ac7/proto/sup/sup.proto#L1134
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_CONTACT_SYNC_IMPRESSION_COUNT"] = 246] = "SUP_FHP_CONTACT_SYNC_IMPRESSION_COUNT";
    /**
     * SUP_FHP_NOTIFICATION_PERMISSION_IMPRESSION_COUNT - SUP's FHP notification permission prompt impression counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/fc53ac7/proto/sup/sup.proto#L1136
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_NOTIFICATION_PERMISSION_IMPRESSION_COUNT"] = 247] = "SUP_FHP_NOTIFICATION_PERMISSION_IMPRESSION_COUNT";
    /**
     * SUP_FHP_PHONE_VERIFICATION_IMPRESSION_COUNT - SUP's FHP phone verification prompt impression counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/fc53ac7/proto/sup/sup.proto#L1138
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_PHONE_VERIFICATION_IMPRESSION_COUNT"] = 248] = "SUP_FHP_PHONE_VERIFICATION_IMPRESSION_COUNT";
    /**
     * SUP_FHP_EMAIL_VERIFICATION_IMPRESSION_COUNT - SUP's FHP email verification prompt impression counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/fc53ac7/proto/sup/sup.proto#L1140
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_EMAIL_VERIFICATION_IMPRESSION_COUNT"] = 249] = "SUP_FHP_EMAIL_VERIFICATION_IMPRESSION_COUNT";
    /** MEMORIES_COUNT - Num of memories snaps user has */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MEMORIES_COUNT"] = 250] = "MEMORIES_COUNT";
    /**
     * SUP_FHP_CONTACT_SYNC_DISMISS_COUNT - SUP's FHP contact sync prompt dismiss counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1160
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_CONTACT_SYNC_DISMISS_COUNT"] = 251] = "SUP_FHP_CONTACT_SYNC_DISMISS_COUNT";
    /**
     * SUP_FHP_NOTIFICATION_PERMISSION_DISMISS_COUNT - SUP's FHP notification permission prompt dismiss counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1162
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_NOTIFICATION_PERMISSION_DISMISS_COUNT"] = 252] = "SUP_FHP_NOTIFICATION_PERMISSION_DISMISS_COUNT";
    /**
     * SUP_FHP_PHONE_VERIFICATION_DISMISS_COUNT - SUP's FHP phone verification prompt dismiss counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1164
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_PHONE_VERIFICATION_DISMISS_COUNT"] = 253] = "SUP_FHP_PHONE_VERIFICATION_DISMISS_COUNT";
    /**
     * SUP_FHP_EMAIL_VERIFICATION_DISMISS_COUNT - SUP's FHP email verification prompt dismiss counter:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/29934fd/proto/sup/sup.proto#L1166
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_EMAIL_VERIFICATION_DISMISS_COUNT"] = 254] = "SUP_FHP_EMAIL_VERIFICATION_DISMISS_COUNT";
    /** SERVER_ONLY - Server side property to mark a config is meant to be consumed by server callers (enforce serving platform initiative) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SERVER_ONLY"] = 255] = "SERVER_ONLY";
    /** HAS_ACTIVE_SNAPCHAT_PLUS - Whether user has active Snapchat+ subscription in Atlas's UserData plus_subscription_info property */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_ACTIVE_SNAPCHAT_PLUS"] = 256] = "HAS_ACTIVE_SNAPCHAT_PLUS";
    /** SUP_FST_SNAP_PLUS_IMPRESSION_COUNT - Client Property of FST snap plus takeover impression count by the SUP property (ID: 672) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_SNAP_PLUS_IMPRESSION_COUNT"] = 257] = "SUP_FST_SNAP_PLUS_IMPRESSION_COUNT";
    /** SUP_FST_SNAP_PLUS_LAST_IMPRESSION_TIME_SECS_TO_NOW - Client Property of FST snap plus takeover last impression time in secs to now by the SUP property (ID: 673) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_SNAP_PLUS_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 258] = "SUP_FST_SNAP_PLUS_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /**
     * CONFIG_TE_ENABLED - Server side property to enable gradual rollout of config level targeting expression.
     * Property will be used only in the backend and excluded from CMS
     * Property will be deprecated after rollout is 100%
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CONFIG_TE_ENABLED"] = 259] = "CONFIG_TE_ENABLED";
    /** SNAP_KIT_OAUTH_ID - OAuth Client ID identifying the source third party application for Snap Kit content */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAP_KIT_OAUTH_ID"] = 260] = "SNAP_KIT_OAUTH_ID";
    /** ORGANIZATION_TYPE - Organization type of advertiser purchasing ads */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ORGANIZATION_TYPE"] = 261] = "ORGANIZATION_TYPE";
    /**
     * CHUNK_UPLOAD_SUPPORT_REQUIRED - Client provided boolean that represent whether the config
     * needs to support uploading in a chunked/streaming manner
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CHUNK_UPLOAD_SUPPORT_REQUIRED"] = 262] = "CHUNK_UPLOAD_SUPPORT_REQUIRED";
    /** SUP_FST_IOS_LOCKSCREEN_WIDGET_IMPRESSION_COUNT - SUP's FST iOS lock screen widgets impression count (ID: 696) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_IOS_LOCKSCREEN_WIDGET_IMPRESSION_COUNT"] = 263] = "SUP_FST_IOS_LOCKSCREEN_WIDGET_IMPRESSION_COUNT";
    /** SUP_FST_IOS_LOCKSCREEN_WIDGET_LAST_IMPRESSION_TIME_SECS_TO_NOW - SUP's FST iOS lock screen widgets last impression time in seconds to now (ID: 697) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_IOS_LOCKSCREEN_WIDGET_LAST_IMPRESSION_TIME_SECS_TO_NOW"] = 264] = "SUP_FST_IOS_LOCKSCREEN_WIDGET_LAST_IMPRESSION_TIME_SECS_TO_NOW";
    /** SUP_FST_IOS_LOCKSCREEN_WIDGET_CLICK_COUNT - SUP's FST iOS lock screen widgets prompt interaction counter (ID: 698) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FST_IOS_LOCKSCREEN_WIDGET_CLICK_COUNT"] = 265] = "SUP_FST_IOS_LOCKSCREEN_WIDGET_CLICK_COUNT";
    /** SUP_PAC_MY_PROFILE_IOS_LOCKSCREEN_WIDGET_CLICK_COUNT - SUP's PAC my profile iOS lock screen widgets prompt interaction count (ID: 699) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_MY_PROFILE_IOS_LOCKSCREEN_WIDGET_CLICK_COUNT"] = 266] = "SUP_PAC_MY_PROFILE_IOS_LOCKSCREEN_WIDGET_CLICK_COUNT";
    /** SUP_PAC_MY_PROFILE_IOS_LOCKSCREEN_WIDGET_DISMISS_COUNT - SUP's PAC my profile iOS lock screen widgets dismiss count (ID: 700) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_PAC_MY_PROFILE_IOS_LOCKSCREEN_WIDGET_DISMISS_COUNT"] = 267] = "SUP_PAC_MY_PROFILE_IOS_LOCKSCREEN_WIDGET_DISMISS_COUNT";
    /** SUP_IOS_LOCK_SCREEN_WIDGET_ENABLED - SUP's iOS lock screen widget has been enabled (ID: 701) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_IOS_LOCK_SCREEN_WIDGET_ENABLED"] = 268] = "SUP_IOS_LOCK_SCREEN_WIDGET_ENABLED";
    /** CLOUDFRONT_POP - The last known CloudFront Point of Presence used */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CLOUDFRONT_POP"] = 269] = "CLOUDFRONT_POP";
    /** BILLBOARD_CAMPAIGN_LOCAL_FIRST_IMPRESSION_TIME_SECS_TO_NOW - Billboard campaign level locally tracked first impresstion time to now */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_FIRST_IMPRESSION_TIME_SECS_TO_NOW"] = 270] = "BILLBOARD_CAMPAIGN_LOCAL_FIRST_IMPRESSION_TIME_SECS_TO_NOW";
    /** BILLBOARD_CAMPAIGN_LOCAL_CLICK_COUNT - Billboard campaign level locally tracked click count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_CLICK_COUNT"] = 271] = "BILLBOARD_CAMPAIGN_LOCAL_CLICK_COUNT";
    /** BILLBOARD_CAMPAIGN_LOCAL_INTERACTION_COUNT - Billboard campaign level locally tracked interaction count */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_INTERACTION_COUNT"] = 272] = "BILLBOARD_CAMPAIGN_LOCAL_INTERACTION_COUNT";
    /** BILLBOARD_CAMPAIGN_LOCAL_LAST_INTERACTION_TIME_SECS_TO_NOW - Billboard campaign level locally tracked last interaction time to now */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BILLBOARD_CAMPAIGN_LOCAL_LAST_INTERACTION_TIME_SECS_TO_NOW"] = 273] = "BILLBOARD_CAMPAIGN_LOCAL_LAST_INTERACTION_TIME_SECS_TO_NOW";
    /** SNAP_PRIVACY - Atlas enum property that indicates a user's snap privacy settings (Friends vs. Everyone) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SNAP_PRIVACY"] = 274] = "SNAP_PRIVACY";
    /** FST_LOCK_SCREEN_WIDGET_BILLBOARD_LAUNCHED_FROM_PUSH - Lock screen widgets billboard - app open via push notification */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["FST_LOCK_SCREEN_WIDGET_BILLBOARD_LAUNCHED_FROM_PUSH"] = 275] = "FST_LOCK_SCREEN_WIDGET_BILLBOARD_LAUNCHED_FROM_PUSH";
    /** WEB_SCREEN_WIDTH - Web browser screen width in CSS pixels */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["WEB_SCREEN_WIDTH"] = 276] = "WEB_SCREEN_WIDTH";
    /** WEB_SCREEN_HEIGHT - Web browser screen height in CSS pixels */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["WEB_SCREEN_HEIGHT"] = 277] = "WEB_SCREEN_HEIGHT";
    /** ADS_INTERFACES_IS_NEW_ORGANIZATION - Is a new organization in ads interfaces UI */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ADS_INTERFACES_IS_NEW_ORGANIZATION"] = 278] = "ADS_INTERFACES_IS_NEW_ORGANIZATION";
    /**
     * SUP_FHP_REGISTER_TO_VOTE_CAMPAIGN_LAST_DISMISS_TIME_MILLIS_TO_NOW - SUP's fhp register to vote campaign dismiss time in millis to now:
     * https://github.sc-corp.net/Snapchat/pb_schema/blob/ab264e8/proto/sup/sup.proto#L1304
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SUP_FHP_REGISTER_TO_VOTE_CAMPAIGN_LAST_DISMISS_TIME_MILLIS_TO_NOW"] = 279] = "SUP_FHP_REGISTER_TO_VOTE_CAMPAIGN_LAST_DISMISS_TIME_MILLIS_TO_NOW";
    /** GHE_ORGANIZATION - The Github Enterprise organization */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GHE_ORGANIZATION"] = 280] = "GHE_ORGANIZATION";
    /** GHE_REPOSITORY - The Github Enterprise Repository, which is contained by a GHE organization */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GHE_REPOSITORY"] = 281] = "GHE_REPOSITORY";
    /** GHE_USER_EMAIL - In the context of Machamp, the user identifier (email) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["GHE_USER_EMAIL"] = 282] = "GHE_USER_EMAIL";
    /** BUILD_DEFINITION_ID - In the context of Machamp, the build definition identifier is a UUID hash of the GHE organization and and repository. */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BUILD_DEFINITION_ID"] = 283] = "BUILD_DEFINITION_ID";
    /** BUILD_DEFINITION_NAME - In the context of Machamp, the build definition name is name of the build from the build.yaml */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["BUILD_DEFINITION_NAME"] = 284] = "BUILD_DEFINITION_NAME";
    /** LCA_PRINCIPAL - LCA Principal of the service calling Circumstance Engine */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["LCA_PRINCIPAL"] = 285] = "LCA_PRINCIPAL";
    /**
     * MEDIA_PERFORMANCE_CLASS - A performance class defines a set of device capabilities by Android
     * e.g. 30, 31, See https://android-developers.googleblog.com/2022/03/using-performance-class-to-optimize.html
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["MEDIA_PERFORMANCE_CLASS"] = 286] = "MEDIA_PERFORMANCE_CLASS";
    /** COMMUNITY_COUNT - Number of Communities user is in */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["COMMUNITY_COUNT"] = 287] = "COMMUNITY_COUNT";
    /** SCREEN_ASPECT_RATIO - The screen aspect ratio. It's the result of SCREEN_WIDTH / SCREEN_HEIGHT */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["SCREEN_ASPECT_RATIO"] = 290] = "SCREEN_ASPECT_RATIO";
    /** RECIPIENTS_SUPPORT_FMP4 - A boolean indicating whether a group of recipients support fMP4 playback */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["RECIPIENTS_SUPPORT_FMP4"] = 291] = "RECIPIENTS_SUPPORT_FMP4";
    /**
     * CAMEOS_ENGAGEMENT_LEVEL - Cameos engagement level based on number of Cameos views in the last 7 days.
     * e.g. IDLE, CASUAL, REGULAR, POWER
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["CAMEOS_ENGAGEMENT_LEVEL"] = 292] = "CAMEOS_ENGAGEMENT_LEVEL";
    /**
     * HAS_CAMEOS - Whether the user has Cameos.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_CAMEOS"] = 293] = "HAS_CAMEOS";
    /**
     * IS_ACTIVE_LENS_VIDEO_CHAT_USER - Whether the user has interacted with lenses in video chat in the last 7 days.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["IS_ACTIVE_LENS_VIDEO_CHAT_USER"] = 294] = "IS_ACTIVE_LENS_VIDEO_CHAT_USER";
    /**
     * NUM_SPOTLIGHT_POSTS_L7 - The number of Spotlight posts a user has made in the last 7 days.
     * e.g. 0, 100, 1000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NUM_SPOTLIGHT_POSTS_L7"] = 295] = "NUM_SPOTLIGHT_POSTS_L7";
    /**
     * NUM_MAP_POSTS_L7 - The number of Map posts a user has made in the last 7 days.
     * e.g. 0, 100, 1000
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["NUM_MAP_POSTS_L7"] = 296] = "NUM_MAP_POSTS_L7";
    /**
     * HAS_CREATED_PUBLIC_PROFILE - Whether a user has created a public profile.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_CREATED_PUBLIC_PROFILE"] = 297] = "HAS_CREATED_PUBLIC_PROFILE";
    /**
     * HAS_PUBLIC_PROFILE_ACCESS_VIA_ROLE - Whether a user has access to a public profile via a role.
     * e.g. TRUE, FALSE
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_PUBLIC_PROFILE_ACCESS_VIA_ROLE"] = 298] = "HAS_PUBLIC_PROFILE_ACCESS_VIA_ROLE";
    /**
     * USER_HAS_DENIED_CAMERA_PERM - A boolean value indicating whether the user has denied camera permission. And the property
     * value would remain TRUE for users who have ever denied camera permission since first time
     * of reading the property value.
     * New users are by default denied camera permission.
     * e.g. TRUE, FALSE
     *
     * @deprecated
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_HAS_DENIED_CAMERA_PERM"] = 299] = "USER_HAS_DENIED_CAMERA_PERM";
    /**
     * DAYS_SINCE_LAST_CAMERA_PERM_DENY - Integer value represents the number of days since last time the user denied camera permission.
     * Default value is -1 if user has no record of denying camera permission (the user has granted camera permission permanently).
     */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_LAST_CAMERA_PERM_DENY"] = 300] = "DAYS_SINCE_LAST_CAMERA_PERM_DENY";
    /** DAYS_SINCE_AD_ORG_JOIN - The days since the user last joined an ads manager organization */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_AD_ORG_JOIN"] = 301] = "DAYS_SINCE_AD_ORG_JOIN";
    /** DAYS_SINCE_FIRST_AD_CREATE - The days since the user created an ad within ads manager via their ad organization */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_FIRST_AD_CREATE"] = 302] = "DAYS_SINCE_FIRST_AD_CREATE";
    /** ORGANIZATION_COUNTRY - Organization country */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["ORGANIZATION_COUNTRY"] = 303] = "ORGANIZATION_COUNTRY";
    /** DAYS_SINCE_FIRST_DWEB_VISIT - The days since the user first visited dWeb (Web Chat) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_FIRST_DWEB_VISIT"] = 304] = "DAYS_SINCE_FIRST_DWEB_VISIT";
    /** DAYS_SINCE_LAST_DWEB_VISIT - The days since the user has last visited dWeb (Web Chat) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["DAYS_SINCE_LAST_DWEB_VISIT"] = 305] = "DAYS_SINCE_LAST_DWEB_VISIT";
    /** WEEKS_SINCE_USING_DWEB - The weeks group in which the user has been absent from dWeb (Web Chat) */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["WEEKS_SINCE_USING_DWEB"] = 306] = "WEEKS_SINCE_USING_DWEB";
    /** HAS_LENS - Whether a capture session has lens */
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["HAS_LENS"] = 307] = "HAS_LENS";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["USER_GROUP"] = 9999] = "USER_GROUP";
    StudyMetadata_TargetingExpression_Property[StudyMetadata_TargetingExpression_Property["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StudyMetadata_TargetingExpression_Property = exports.StudyMetadata_TargetingExpression_Property || (exports.StudyMetadata_TargetingExpression_Property = {}));
const baseUserInfo = {
    userId: "",
    userName: "",
    isEmployee: false,
    isTestUser: false,
    creationTs: 0,
    stickyCountry: "",
    snapProStatus: 0,
    mutableUserName: "",
    said: "",
};
exports.UserInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userId !== "") {
            writer.uint32(10).string(message.userId);
        }
        if (message.userName !== "") {
            writer.uint32(18).string(message.userName);
        }
        if (message.isEmployee === true) {
            writer.uint32(24).bool(message.isEmployee);
        }
        if (message.isTestUser === true) {
            writer.uint32(32).bool(message.isTestUser);
        }
        if (message.creationTs !== 0) {
            writer.uint32(40).uint64(message.creationTs);
        }
        if (message.stickyCountry !== "") {
            writer.uint32(50).string(message.stickyCountry);
        }
        if (message.email !== undefined) {
            exports.Email.encode(message.email, writer.uint32(58).fork()).ldelim();
        }
        if (message.phone !== undefined) {
            exports.Phone.encode(message.phone, writer.uint32(66).fork()).ldelim();
        }
        if (message.snapProStatus !== 0) {
            writer.uint32(72).int32(message.snapProStatus);
        }
        if (message.mutableUserName !== "") {
            writer.uint32(82).string(message.mutableUserName);
        }
        if (message.said !== "") {
            writer.uint32(90).string(message.said);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUserInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userId = reader.string();
                    break;
                case 2:
                    message.userName = reader.string();
                    break;
                case 3:
                    message.isEmployee = reader.bool();
                    break;
                case 4:
                    message.isTestUser = reader.bool();
                    break;
                case 5:
                    message.creationTs = longToNumber(reader.uint64());
                    break;
                case 6:
                    message.stickyCountry = reader.string();
                    break;
                case 7:
                    message.email = exports.Email.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.phone = exports.Phone.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.snapProStatus = reader.int32();
                    break;
                case 10:
                    message.mutableUserName = reader.string();
                    break;
                case 11:
                    message.said = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUserInfo);
        if (object.userId !== undefined && object.userId !== null) {
            message.userId = object.userId;
        }
        else {
            message.userId = "";
        }
        if (object.userName !== undefined && object.userName !== null) {
            message.userName = object.userName;
        }
        else {
            message.userName = "";
        }
        if (object.isEmployee !== undefined && object.isEmployee !== null) {
            message.isEmployee = object.isEmployee;
        }
        else {
            message.isEmployee = false;
        }
        if (object.isTestUser !== undefined && object.isTestUser !== null) {
            message.isTestUser = object.isTestUser;
        }
        else {
            message.isTestUser = false;
        }
        if (object.creationTs !== undefined && object.creationTs !== null) {
            message.creationTs = object.creationTs;
        }
        else {
            message.creationTs = 0;
        }
        if (object.stickyCountry !== undefined && object.stickyCountry !== null) {
            message.stickyCountry = object.stickyCountry;
        }
        else {
            message.stickyCountry = "";
        }
        if (object.email !== undefined && object.email !== null) {
            message.email = exports.Email.fromPartial(object.email);
        }
        else {
            message.email = undefined;
        }
        if (object.phone !== undefined && object.phone !== null) {
            message.phone = exports.Phone.fromPartial(object.phone);
        }
        else {
            message.phone = undefined;
        }
        if (object.snapProStatus !== undefined && object.snapProStatus !== null) {
            message.snapProStatus = object.snapProStatus;
        }
        else {
            message.snapProStatus = 0;
        }
        if (object.mutableUserName !== undefined &&
            object.mutableUserName !== null) {
            message.mutableUserName = object.mutableUserName;
        }
        else {
            message.mutableUserName = "";
        }
        if (object.said !== undefined && object.said !== null) {
            message.said = object.said;
        }
        else {
            message.said = "";
        }
        return message;
    },
};
const baseEmail = {
    isEmailEmpty: false,
    isEmailVerified: false,
    isEmailPendingVerificationEmpty: false,
};
exports.Email = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isEmailEmpty === true) {
            writer.uint32(8).bool(message.isEmailEmpty);
        }
        if (message.isEmailVerified === true) {
            writer.uint32(16).bool(message.isEmailVerified);
        }
        if (message.isEmailPendingVerificationEmpty === true) {
            writer.uint32(24).bool(message.isEmailPendingVerificationEmpty);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseEmail);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isEmailEmpty = reader.bool();
                    break;
                case 2:
                    message.isEmailVerified = reader.bool();
                    break;
                case 3:
                    message.isEmailPendingVerificationEmpty = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseEmail);
        if (object.isEmailEmpty !== undefined && object.isEmailEmpty !== null) {
            message.isEmailEmpty = object.isEmailEmpty;
        }
        else {
            message.isEmailEmpty = false;
        }
        if (object.isEmailVerified !== undefined &&
            object.isEmailVerified !== null) {
            message.isEmailVerified = object.isEmailVerified;
        }
        else {
            message.isEmailVerified = false;
        }
        if (object.isEmailPendingVerificationEmpty !== undefined &&
            object.isEmailPendingVerificationEmpty !== null) {
            message.isEmailPendingVerificationEmpty =
                object.isEmailPendingVerificationEmpty;
        }
        else {
            message.isEmailPendingVerificationEmpty = false;
        }
        return message;
    },
};
const baseUserAgentInfo = {
    osType: "",
    osVersion: "",
    appVersion: "",
    appBuild: "",
    appVariant: "",
    deviceModel: "",
    originalUserAgentString: "",
};
exports.UserAgentInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.osType !== "") {
            writer.uint32(10).string(message.osType);
        }
        if (message.osVersion !== "") {
            writer.uint32(18).string(message.osVersion);
        }
        if (message.appVersion !== "") {
            writer.uint32(26).string(message.appVersion);
        }
        if (message.appBuild !== "") {
            writer.uint32(34).string(message.appBuild);
        }
        if (message.appVariant !== "") {
            writer.uint32(42).string(message.appVariant);
        }
        if (message.deviceModel !== "") {
            writer.uint32(50).string(message.deviceModel);
        }
        if (message.originalUserAgentString !== "") {
            writer.uint32(58).string(message.originalUserAgentString);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUserAgentInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.osType = reader.string();
                    break;
                case 2:
                    message.osVersion = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.string();
                    break;
                case 4:
                    message.appBuild = reader.string();
                    break;
                case 5:
                    message.appVariant = reader.string();
                    break;
                case 6:
                    message.deviceModel = reader.string();
                    break;
                case 7:
                    message.originalUserAgentString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUserAgentInfo);
        if (object.osType !== undefined && object.osType !== null) {
            message.osType = object.osType;
        }
        else {
            message.osType = "";
        }
        if (object.osVersion !== undefined && object.osVersion !== null) {
            message.osVersion = object.osVersion;
        }
        else {
            message.osVersion = "";
        }
        if (object.appVersion !== undefined && object.appVersion !== null) {
            message.appVersion = object.appVersion;
        }
        else {
            message.appVersion = "";
        }
        if (object.appBuild !== undefined && object.appBuild !== null) {
            message.appBuild = object.appBuild;
        }
        else {
            message.appBuild = "";
        }
        if (object.appVariant !== undefined && object.appVariant !== null) {
            message.appVariant = object.appVariant;
        }
        else {
            message.appVariant = "";
        }
        if (object.deviceModel !== undefined && object.deviceModel !== null) {
            message.deviceModel = object.deviceModel;
        }
        else {
            message.deviceModel = "";
        }
        if (object.originalUserAgentString !== undefined &&
            object.originalUserAgentString !== null) {
            message.originalUserAgentString = object.originalUserAgentString;
        }
        else {
            message.originalUserAgentString = "";
        }
        return message;
    },
};
const basePhone = { isPhoneEmpty: false, isPhoneVerified: false };
exports.Phone = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isPhoneEmpty === true) {
            writer.uint32(8).bool(message.isPhoneEmpty);
        }
        if (message.isPhoneVerified === true) {
            writer.uint32(16).bool(message.isPhoneVerified);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePhone);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isPhoneEmpty = reader.bool();
                    break;
                case 2:
                    message.isPhoneVerified = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, basePhone);
        if (object.isPhoneEmpty !== undefined && object.isPhoneEmpty !== null) {
            message.isPhoneEmpty = object.isPhoneEmpty;
        }
        else {
            message.isPhoneEmpty = false;
        }
        if (object.isPhoneVerified !== undefined &&
            object.isPhoneVerified !== null) {
            message.isPhoneVerified = object.isPhoneVerified;
        }
        else {
            message.isPhoneVerified = false;
        }
        return message;
    },
};
const baseGetConfigsValueByPropertiesRequest = {
    requestedStudies: "",
    deviceId: "",
    userAgent: "",
    ipAddress: "",
    countryCode: "",
    city: "",
    region: "",
    locale: "",
    srcOfOrigin: 0,
    enableDebug: false,
    disableExposureLogging: false,
};
exports.GetConfigsValueByPropertiesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.configs) {
            exports.GetConfigsValueByPropertiesRequest_ConfigMetadata.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.requestedStudies) {
            writer.uint32(18).string(v);
        }
        if (message.userInfo !== undefined) {
            exports.UserInfo.encode(message.userInfo, writer.uint32(26).fork()).ldelim();
        }
        if (message.deviceId !== "") {
            writer.uint32(34).string(message.deviceId);
        }
        if (message.userAgent !== "") {
            writer.uint32(42).string(message.userAgent);
        }
        if (message.ipAddress !== "") {
            writer.uint32(50).string(message.ipAddress);
        }
        if (message.countryCode !== "") {
            writer.uint32(58).string(message.countryCode);
        }
        if (message.city !== "") {
            writer.uint32(66).string(message.city);
        }
        if (message.region !== "") {
            writer.uint32(74).string(message.region);
        }
        if (message.locale !== "") {
            writer.uint32(82).string(message.locale);
        }
        if (message.userAgentInfo !== undefined) {
            exports.UserAgentInfo.encode(message.userAgentInfo, writer.uint32(90).fork()).ldelim();
        }
        if (message.srcOfOrigin !== 0) {
            writer.uint32(96).int32(message.srcOfOrigin);
        }
        if (message.enableDebug === true) {
            writer.uint32(104).bool(message.enableDebug);
        }
        if (message.disableExposureLogging === true) {
            writer.uint32(112).bool(message.disableExposureLogging);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigsValueByPropertiesRequest);
        message.configs = [];
        message.requestedStudies = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.configs.push(exports.GetConfigsValueByPropertiesRequest_ConfigMetadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.requestedStudies.push(reader.string());
                    break;
                case 3:
                    message.userInfo = exports.UserInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.deviceId = reader.string();
                    break;
                case 5:
                    message.userAgent = reader.string();
                    break;
                case 6:
                    message.ipAddress = reader.string();
                    break;
                case 7:
                    message.countryCode = reader.string();
                    break;
                case 8:
                    message.city = reader.string();
                    break;
                case 9:
                    message.region = reader.string();
                    break;
                case 10:
                    message.locale = reader.string();
                    break;
                case 11:
                    message.userAgentInfo = exports.UserAgentInfo.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.srcOfOrigin = reader.int32();
                    break;
                case 13:
                    message.enableDebug = reader.bool();
                    break;
                case 14:
                    message.disableExposureLogging = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigsValueByPropertiesRequest);
        message.configs = [];
        message.requestedStudies = [];
        if (object.configs !== undefined && object.configs !== null) {
            for (const e of object.configs) {
                message.configs.push(exports.GetConfigsValueByPropertiesRequest_ConfigMetadata.fromPartial(e));
            }
        }
        if (object.requestedStudies !== undefined &&
            object.requestedStudies !== null) {
            for (const e of object.requestedStudies) {
                message.requestedStudies.push(e);
            }
        }
        if (object.userInfo !== undefined && object.userInfo !== null) {
            message.userInfo = exports.UserInfo.fromPartial(object.userInfo);
        }
        else {
            message.userInfo = undefined;
        }
        if (object.deviceId !== undefined && object.deviceId !== null) {
            message.deviceId = object.deviceId;
        }
        else {
            message.deviceId = "";
        }
        if (object.userAgent !== undefined && object.userAgent !== null) {
            message.userAgent = object.userAgent;
        }
        else {
            message.userAgent = "";
        }
        if (object.ipAddress !== undefined && object.ipAddress !== null) {
            message.ipAddress = object.ipAddress;
        }
        else {
            message.ipAddress = "";
        }
        if (object.countryCode !== undefined && object.countryCode !== null) {
            message.countryCode = object.countryCode;
        }
        else {
            message.countryCode = "";
        }
        if (object.city !== undefined && object.city !== null) {
            message.city = object.city;
        }
        else {
            message.city = "";
        }
        if (object.region !== undefined && object.region !== null) {
            message.region = object.region;
        }
        else {
            message.region = "";
        }
        if (object.locale !== undefined && object.locale !== null) {
            message.locale = object.locale;
        }
        else {
            message.locale = "";
        }
        if (object.userAgentInfo !== undefined && object.userAgentInfo !== null) {
            message.userAgentInfo = exports.UserAgentInfo.fromPartial(object.userAgentInfo);
        }
        else {
            message.userAgentInfo = undefined;
        }
        if (object.srcOfOrigin !== undefined && object.srcOfOrigin !== null) {
            message.srcOfOrigin = object.srcOfOrigin;
        }
        else {
            message.srcOfOrigin = 0;
        }
        if (object.enableDebug !== undefined && object.enableDebug !== null) {
            message.enableDebug = object.enableDebug;
        }
        else {
            message.enableDebug = false;
        }
        if (object.disableExposureLogging !== undefined &&
            object.disableExposureLogging !== null) {
            message.disableExposureLogging = object.disableExposureLogging;
        }
        else {
            message.disableExposureLogging = false;
        }
        return message;
    },
};
const baseGetConfigsValueByPropertiesRequest_ConfigMetadata = {
    configName: "",
    version: 0,
};
exports.GetConfigsValueByPropertiesRequest_ConfigMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.configName !== "") {
            writer.uint32(10).string(message.configName);
        }
        if (message.version !== 0) {
            writer.uint32(16).uint32(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigsValueByPropertiesRequest_ConfigMetadata);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.configName = reader.string();
                    break;
                case 2:
                    message.version = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigsValueByPropertiesRequest_ConfigMetadata);
        if (object.configName !== undefined && object.configName !== null) {
            message.configName = object.configName;
        }
        else {
            message.configName = "";
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        return message;
    },
};
const baseABTargetingMetadata = { id: "", version: 0 };
exports.ABTargetingMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.version !== 0) {
            writer.uint32(16).uint32(message.version);
        }
        if (message.clientTargetingExpression !== undefined) {
            config_result_1.ClientTargetingExpression.encode(message.clientTargetingExpression, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseABTargetingMetadata);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.version = reader.uint32();
                    break;
                case 3:
                    message.clientTargetingExpression = config_result_1.ClientTargetingExpression.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseABTargetingMetadata);
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = "";
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        if (object.clientTargetingExpression !== undefined &&
            object.clientTargetingExpression !== null) {
            message.clientTargetingExpression = config_result_1.ClientTargetingExpression.fromPartial(object.clientTargetingExpression);
        }
        else {
            message.clientTargetingExpression = undefined;
        }
        return message;
    },
};
const baseABStudyServingMetadata = { id: "" };
exports.ABStudyServingMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        for (const v of message.targetingMetadata) {
            exports.ABTargetingMetadata.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseABStudyServingMetadata);
        message.targetingMetadata = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.targetingMetadata.push(exports.ABTargetingMetadata.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseABStudyServingMetadata);
        message.targetingMetadata = [];
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = "";
        }
        if (object.targetingMetadata !== undefined &&
            object.targetingMetadata !== null) {
            for (const e of object.targetingMetadata) {
                message.targetingMetadata.push(exports.ABTargetingMetadata.fromPartial(e));
            }
        }
        return message;
    },
};
const baseTargetingInfo = {
    deviceId: "",
    userAgent: "",
    ipAddress: "",
    countryCode: "",
    city: "",
    region: "",
    locale: "",
    srcOfOrigin: 0,
};
exports.TargetingInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.userInfo !== undefined) {
            exports.UserInfo.encode(message.userInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.deviceId !== "") {
            writer.uint32(18).string(message.deviceId);
        }
        if (message.userAgent !== "") {
            writer.uint32(26).string(message.userAgent);
        }
        if (message.ipAddress !== "") {
            writer.uint32(34).string(message.ipAddress);
        }
        if (message.countryCode !== "") {
            writer.uint32(42).string(message.countryCode);
        }
        if (message.city !== "") {
            writer.uint32(50).string(message.city);
        }
        if (message.region !== "") {
            writer.uint32(58).string(message.region);
        }
        if (message.locale !== "") {
            writer.uint32(66).string(message.locale);
        }
        if (message.userAgentInfo !== undefined) {
            exports.UserAgentInfo.encode(message.userAgentInfo, writer.uint32(74).fork()).ldelim();
        }
        if (message.srcOfOrigin !== 0) {
            writer.uint32(80).int32(message.srcOfOrigin);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTargetingInfo);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.userInfo = exports.UserInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.deviceId = reader.string();
                    break;
                case 3:
                    message.userAgent = reader.string();
                    break;
                case 4:
                    message.ipAddress = reader.string();
                    break;
                case 5:
                    message.countryCode = reader.string();
                    break;
                case 6:
                    message.city = reader.string();
                    break;
                case 7:
                    message.region = reader.string();
                    break;
                case 8:
                    message.locale = reader.string();
                    break;
                case 9:
                    message.userAgentInfo = exports.UserAgentInfo.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.srcOfOrigin = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTargetingInfo);
        if (object.userInfo !== undefined && object.userInfo !== null) {
            message.userInfo = exports.UserInfo.fromPartial(object.userInfo);
        }
        else {
            message.userInfo = undefined;
        }
        if (object.deviceId !== undefined && object.deviceId !== null) {
            message.deviceId = object.deviceId;
        }
        else {
            message.deviceId = "";
        }
        if (object.userAgent !== undefined && object.userAgent !== null) {
            message.userAgent = object.userAgent;
        }
        else {
            message.userAgent = "";
        }
        if (object.ipAddress !== undefined && object.ipAddress !== null) {
            message.ipAddress = object.ipAddress;
        }
        else {
            message.ipAddress = "";
        }
        if (object.countryCode !== undefined && object.countryCode !== null) {
            message.countryCode = object.countryCode;
        }
        else {
            message.countryCode = "";
        }
        if (object.city !== undefined && object.city !== null) {
            message.city = object.city;
        }
        else {
            message.city = "";
        }
        if (object.region !== undefined && object.region !== null) {
            message.region = object.region;
        }
        else {
            message.region = "";
        }
        if (object.locale !== undefined && object.locale !== null) {
            message.locale = object.locale;
        }
        else {
            message.locale = "";
        }
        if (object.userAgentInfo !== undefined && object.userAgentInfo !== null) {
            message.userAgentInfo = exports.UserAgentInfo.fromPartial(object.userAgentInfo);
        }
        else {
            message.userAgentInfo = undefined;
        }
        if (object.srcOfOrigin !== undefined && object.srcOfOrigin !== null) {
            message.srcOfOrigin = object.srcOfOrigin;
        }
        else {
            message.srcOfOrigin = 0;
        }
        return message;
    },
};
const baseGetConfigOverridesByPropertiesRequest = {
    requestedCofConfigNames: "",
    disableExposureLogging: false,
    enableDebug: false,
};
exports.GetConfigOverridesByPropertiesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetingInfo !== undefined) {
            exports.TargetingInfo.encode(message.targetingInfo, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.matchedAbStudyMetadata) {
            exports.ABStudyServingMetadata.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.requestedCofConfigNames) {
            writer.uint32(26).string(v);
        }
        if (message.disableExposureLogging === true) {
            writer.uint32(32).bool(message.disableExposureLogging);
        }
        if (message.enableDebug === true) {
            writer.uint32(40).bool(message.enableDebug);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigOverridesByPropertiesRequest);
        message.matchedAbStudyMetadata = [];
        message.requestedCofConfigNames = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.targetingInfo = exports.TargetingInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.matchedAbStudyMetadata.push(exports.ABStudyServingMetadata.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.requestedCofConfigNames.push(reader.string());
                    break;
                case 4:
                    message.disableExposureLogging = reader.bool();
                    break;
                case 5:
                    message.enableDebug = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigOverridesByPropertiesRequest);
        message.matchedAbStudyMetadata = [];
        message.requestedCofConfigNames = [];
        if (object.targetingInfo !== undefined && object.targetingInfo !== null) {
            message.targetingInfo = exports.TargetingInfo.fromPartial(object.targetingInfo);
        }
        else {
            message.targetingInfo = undefined;
        }
        if (object.matchedAbStudyMetadata !== undefined &&
            object.matchedAbStudyMetadata !== null) {
            for (const e of object.matchedAbStudyMetadata) {
                message.matchedAbStudyMetadata.push(exports.ABStudyServingMetadata.fromPartial(e));
            }
        }
        if (object.requestedCofConfigNames !== undefined &&
            object.requestedCofConfigNames !== null) {
            for (const e of object.requestedCofConfigNames) {
                message.requestedCofConfigNames.push(e);
            }
        }
        if (object.disableExposureLogging !== undefined &&
            object.disableExposureLogging !== null) {
            message.disableExposureLogging = object.disableExposureLogging;
        }
        else {
            message.disableExposureLogging = false;
        }
        if (object.enableDebug !== undefined && object.enableDebug !== null) {
            message.enableDebug = object.enableDebug;
        }
        else {
            message.enableDebug = false;
        }
        return message;
    },
};
const baseTargetingProperties = { customIsFirstTime: false };
exports.TargetingProperties = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.customIsFirstTime === true) {
            writer.uint32(8).bool(message.customIsFirstTime);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTargetingProperties);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.customIsFirstTime = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseTargetingProperties);
        if (object.customIsFirstTime !== undefined &&
            object.customIsFirstTime !== null) {
            message.customIsFirstTime = object.customIsFirstTime;
        }
        else {
            message.customIsFirstTime = false;
        }
        return message;
    },
};
const baseGetConfigOverridesByRUIDRequest = {
    requestedCofConfigNames: "",
    enableDebug: false,
    disableExposureLogging: false,
    requestedNamespaces: "",
};
exports.GetConfigOverridesByRUIDRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.ruid !== undefined) {
            ruid_1.Ruid.encode(message.ruid, writer.uint32(10).fork()).ldelim();
        }
        if (message.targetingProperties !== undefined) {
            exports.TargetingProperties.encode(message.targetingProperties, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.matchedAbStudyMetadata) {
            exports.ABStudyServingMetadata.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.requestedCofConfigNames) {
            writer.uint32(34).string(v);
        }
        if (message.enableDebug === true) {
            writer.uint32(40).bool(message.enableDebug);
        }
        if (message.disableExposureLogging === true) {
            writer.uint32(48).bool(message.disableExposureLogging);
        }
        for (const v of message.requestedNamespaces) {
            writer.uint32(58).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigOverridesByRUIDRequest);
        message.matchedAbStudyMetadata = [];
        message.requestedCofConfigNames = [];
        message.requestedNamespaces = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.ruid = ruid_1.Ruid.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.targetingProperties = exports.TargetingProperties.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.matchedAbStudyMetadata.push(exports.ABStudyServingMetadata.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.requestedCofConfigNames.push(reader.string());
                    break;
                case 5:
                    message.enableDebug = reader.bool();
                    break;
                case 6:
                    message.disableExposureLogging = reader.bool();
                    break;
                case 7:
                    message.requestedNamespaces.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigOverridesByRUIDRequest);
        message.matchedAbStudyMetadata = [];
        message.requestedCofConfigNames = [];
        message.requestedNamespaces = [];
        if (object.ruid !== undefined && object.ruid !== null) {
            message.ruid = ruid_1.Ruid.fromPartial(object.ruid);
        }
        else {
            message.ruid = undefined;
        }
        if (object.targetingProperties !== undefined &&
            object.targetingProperties !== null) {
            message.targetingProperties = exports.TargetingProperties.fromPartial(object.targetingProperties);
        }
        else {
            message.targetingProperties = undefined;
        }
        if (object.matchedAbStudyMetadata !== undefined &&
            object.matchedAbStudyMetadata !== null) {
            for (const e of object.matchedAbStudyMetadata) {
                message.matchedAbStudyMetadata.push(exports.ABStudyServingMetadata.fromPartial(e));
            }
        }
        if (object.requestedCofConfigNames !== undefined &&
            object.requestedCofConfigNames !== null) {
            for (const e of object.requestedCofConfigNames) {
                message.requestedCofConfigNames.push(e);
            }
        }
        if (object.enableDebug !== undefined && object.enableDebug !== null) {
            message.enableDebug = object.enableDebug;
        }
        else {
            message.enableDebug = false;
        }
        if (object.disableExposureLogging !== undefined &&
            object.disableExposureLogging !== null) {
            message.disableExposureLogging = object.disableExposureLogging;
        }
        else {
            message.disableExposureLogging = false;
        }
        if (object.requestedNamespaces !== undefined &&
            object.requestedNamespaces !== null) {
            for (const e of object.requestedNamespaces) {
                message.requestedNamespaces.push(e);
            }
        }
        return message;
    },
};
const baseGetConfigOverridesByRUIDResponse = {};
exports.GetConfigOverridesByRUIDResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.variableOverrides) {
            exports.COFVariableOverride.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.debugTrace !== undefined) {
            debug_info_1.DebugTrace.encode(message.debugTrace, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigOverridesByRUIDResponse);
        message.variableOverrides = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.variableOverrides.push(exports.COFVariableOverride.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.debugTrace = debug_info_1.DebugTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigOverridesByRUIDResponse);
        message.variableOverrides = [];
        if (object.variableOverrides !== undefined &&
            object.variableOverrides !== null) {
            for (const e of object.variableOverrides) {
                message.variableOverrides.push(exports.COFVariableOverride.fromPartial(e));
            }
        }
        if (object.debugTrace !== undefined && object.debugTrace !== null) {
            message.debugTrace = debug_info_1.DebugTrace.fromPartial(object.debugTrace);
        }
        else {
            message.debugTrace = undefined;
        }
        return message;
    },
};
const baseCOFVariableOverride = {
    namespace: "",
    configName: "",
    expId: 0,
    studyName: "",
    servePlatforms: 0,
    budgetGroupId: 0,
    canSkipAllocationLogging: false,
    ruidType: 0,
    canSkipClientExposureLogging: false,
};
exports.COFVariableOverride = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.namespace !== "") {
            writer.uint32(10).string(message.namespace);
        }
        if (message.configName !== "") {
            writer.uint32(18).string(message.configName);
        }
        if (message.expId !== 0) {
            writer.uint32(24).uint32(message.expId);
        }
        if (message.studyName !== "") {
            writer.uint32(34).string(message.studyName);
        }
        if (message.override !== undefined) {
            value_1.Value.encode(message.override, writer.uint32(42).fork()).ldelim();
        }
        if (message.clientTargetExpression !== undefined) {
            config_result_1.ClientTargetingExpression.encode(message.clientTargetExpression, writer.uint32(50).fork()).ldelim();
        }
        if (message.abStepInfo !== undefined) {
            debug_info_1.AbStepInfo.encode(message.abStepInfo, writer.uint32(58).fork()).ldelim();
        }
        writer.uint32(66).fork();
        for (const v of message.servePlatforms) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.budgetGroupId !== 0) {
            writer.uint32(72).uint32(message.budgetGroupId);
        }
        if (message.canSkipAllocationLogging === true) {
            writer.uint32(80).bool(message.canSkipAllocationLogging);
        }
        if (message.ruidType !== 0) {
            writer.uint32(88).int32(message.ruidType);
        }
        if (message.canSkipClientExposureLogging === true) {
            writer.uint32(96).bool(message.canSkipClientExposureLogging);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCOFVariableOverride);
        message.servePlatforms = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.configName = reader.string();
                    break;
                case 3:
                    message.expId = reader.uint32();
                    break;
                case 4:
                    message.studyName = reader.string();
                    break;
                case 5:
                    message.override = value_1.Value.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.clientTargetExpression = config_result_1.ClientTargetingExpression.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.abStepInfo = debug_info_1.AbStepInfo.decode(reader, reader.uint32());
                    break;
                case 8:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.servePlatforms.push(reader.int32());
                        }
                    }
                    else {
                        message.servePlatforms.push(reader.int32());
                    }
                    break;
                case 9:
                    message.budgetGroupId = reader.uint32();
                    break;
                case 10:
                    message.canSkipAllocationLogging = reader.bool();
                    break;
                case 11:
                    message.ruidType = reader.int32();
                    break;
                case 12:
                    message.canSkipClientExposureLogging = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCOFVariableOverride);
        message.servePlatforms = [];
        if (object.namespace !== undefined && object.namespace !== null) {
            message.namespace = object.namespace;
        }
        else {
            message.namespace = "";
        }
        if (object.configName !== undefined && object.configName !== null) {
            message.configName = object.configName;
        }
        else {
            message.configName = "";
        }
        if (object.expId !== undefined && object.expId !== null) {
            message.expId = object.expId;
        }
        else {
            message.expId = 0;
        }
        if (object.studyName !== undefined && object.studyName !== null) {
            message.studyName = object.studyName;
        }
        else {
            message.studyName = "";
        }
        if (object.override !== undefined && object.override !== null) {
            message.override = value_1.Value.fromPartial(object.override);
        }
        else {
            message.override = undefined;
        }
        if (object.clientTargetExpression !== undefined &&
            object.clientTargetExpression !== null) {
            message.clientTargetExpression = config_result_1.ClientTargetingExpression.fromPartial(object.clientTargetExpression);
        }
        else {
            message.clientTargetExpression = undefined;
        }
        if (object.abStepInfo !== undefined && object.abStepInfo !== null) {
            message.abStepInfo = debug_info_1.AbStepInfo.fromPartial(object.abStepInfo);
        }
        else {
            message.abStepInfo = undefined;
        }
        if (object.servePlatforms !== undefined && object.servePlatforms !== null) {
            for (const e of object.servePlatforms) {
                message.servePlatforms.push(e);
            }
        }
        if (object.budgetGroupId !== undefined && object.budgetGroupId !== null) {
            message.budgetGroupId = object.budgetGroupId;
        }
        else {
            message.budgetGroupId = 0;
        }
        if (object.canSkipAllocationLogging !== undefined &&
            object.canSkipAllocationLogging !== null) {
            message.canSkipAllocationLogging = object.canSkipAllocationLogging;
        }
        else {
            message.canSkipAllocationLogging = false;
        }
        if (object.ruidType !== undefined && object.ruidType !== null) {
            message.ruidType = object.ruidType;
        }
        else {
            message.ruidType = 0;
        }
        if (object.canSkipClientExposureLogging !== undefined &&
            object.canSkipClientExposureLogging !== null) {
            message.canSkipClientExposureLogging =
                object.canSkipClientExposureLogging;
        }
        else {
            message.canSkipClientExposureLogging = false;
        }
        return message;
    },
};
const baseGetConfigOverridesByPropertiesResponse = {};
exports.GetConfigOverridesByPropertiesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.variableOverrides) {
            exports.COFVariableOverride.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigOverridesByPropertiesResponse);
        message.variableOverrides = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.variableOverrides.push(exports.COFVariableOverride.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigOverridesByPropertiesResponse);
        message.variableOverrides = [];
        if (object.variableOverrides !== undefined &&
            object.variableOverrides !== null) {
            for (const e of object.variableOverrides) {
                message.variableOverrides.push(exports.COFVariableOverride.fromPartial(e));
            }
        }
        return message;
    },
};
const baseStudyData = {
    name: "",
    experimentId: 0,
    servePlatforms: 0,
    canSkipAllocationLogging: false,
};
exports.StudyData = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.experimentId !== 0) {
            writer.uint32(16).uint32(message.experimentId);
        }
        Object.entries(message.variables).forEach(([key, value]) => {
            exports.StudyData_VariablesEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        if (message.abStepInfo !== undefined) {
            debug_info_1.AbStepInfo.encode(message.abStepInfo, writer.uint32(34).fork()).ldelim();
        }
        writer.uint32(42).fork();
        for (const v of message.servePlatforms) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.canSkipAllocationLogging === true) {
            writer.uint32(48).bool(message.canSkipAllocationLogging);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyData);
        message.variables = {};
        message.servePlatforms = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.experimentId = reader.uint32();
                    break;
                case 3:
                    const entry3 = exports.StudyData_VariablesEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.variables[entry3.key] = entry3.value;
                    }
                    break;
                case 4:
                    message.abStepInfo = debug_info_1.AbStepInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.servePlatforms.push(reader.int32());
                        }
                    }
                    else {
                        message.servePlatforms.push(reader.int32());
                    }
                    break;
                case 6:
                    message.canSkipAllocationLogging = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyData);
        message.variables = {};
        message.servePlatforms = [];
        if (object.name !== undefined && object.name !== null) {
            message.name = object.name;
        }
        else {
            message.name = "";
        }
        if (object.experimentId !== undefined && object.experimentId !== null) {
            message.experimentId = object.experimentId;
        }
        else {
            message.experimentId = 0;
        }
        if (object.variables !== undefined && object.variables !== null) {
            Object.entries(object.variables).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.variables[key] = String(value);
                }
            });
        }
        if (object.abStepInfo !== undefined && object.abStepInfo !== null) {
            message.abStepInfo = debug_info_1.AbStepInfo.fromPartial(object.abStepInfo);
        }
        else {
            message.abStepInfo = undefined;
        }
        if (object.servePlatforms !== undefined && object.servePlatforms !== null) {
            for (const e of object.servePlatforms) {
                message.servePlatforms.push(e);
            }
        }
        if (object.canSkipAllocationLogging !== undefined &&
            object.canSkipAllocationLogging !== null) {
            message.canSkipAllocationLogging = object.canSkipAllocationLogging;
        }
        else {
            message.canSkipAllocationLogging = false;
        }
        return message;
    },
};
const baseStudyData_VariablesEntry = { key: "", value: "" };
exports.StudyData_VariablesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyData_VariablesEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyData_VariablesEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
const baseGetConfigsValueByPropertiesResponse = {};
exports.GetConfigsValueByPropertiesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studyData) {
            exports.StudyData.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseGetConfigsValueByPropertiesResponse);
        message.studyData = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyData.push(exports.StudyData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseGetConfigsValueByPropertiesResponse);
        message.studyData = [];
        if (object.studyData !== undefined && object.studyData !== null) {
            for (const e of object.studyData) {
                message.studyData.push(exports.StudyData.fromPartial(e));
            }
        }
        return message;
    },
};
const baseUpdateStudyMetadataRequest = { segmentationStudyName: "" };
exports.UpdateStudyMetadataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studyMetadata) {
            exports.StudyMetadata.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.segmentationStudyName !== "") {
            writer.uint32(18).string(message.segmentationStudyName);
        }
        for (const v of message.deletedSegments) {
            exports.UpdateStudyMetadataRequest_StudyIdentity.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateStudyMetadataRequest);
        message.studyMetadata = [];
        message.deletedSegments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyMetadata.push(exports.StudyMetadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.segmentationStudyName = reader.string();
                    break;
                case 3:
                    message.deletedSegments.push(exports.UpdateStudyMetadataRequest_StudyIdentity.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUpdateStudyMetadataRequest);
        message.studyMetadata = [];
        message.deletedSegments = [];
        if (object.studyMetadata !== undefined && object.studyMetadata !== null) {
            for (const e of object.studyMetadata) {
                message.studyMetadata.push(exports.StudyMetadata.fromPartial(e));
            }
        }
        if (object.segmentationStudyName !== undefined &&
            object.segmentationStudyName !== null) {
            message.segmentationStudyName = object.segmentationStudyName;
        }
        else {
            message.segmentationStudyName = "";
        }
        if (object.deletedSegments !== undefined &&
            object.deletedSegments !== null) {
            for (const e of object.deletedSegments) {
                message.deletedSegments.push(exports.UpdateStudyMetadataRequest_StudyIdentity.fromPartial(e));
            }
        }
        return message;
    },
};
const baseUpdateStudyMetadataRequest_StudyIdentity = {
    studyId: "",
    version: 0,
};
exports.UpdateStudyMetadataRequest_StudyIdentity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.studyId !== "") {
            writer.uint32(10).string(message.studyId);
        }
        if (message.version !== 0) {
            writer.uint32(16).uint64(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateStudyMetadataRequest_StudyIdentity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyId = reader.string();
                    break;
                case 2:
                    message.version = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseUpdateStudyMetadataRequest_StudyIdentity);
        if (object.studyId !== undefined && object.studyId !== null) {
            message.studyId = object.studyId;
        }
        else {
            message.studyId = "";
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        return message;
    },
};
const baseStudyMetadata = {
    studyId: "",
    version: 0,
    servePlatforms: 0,
    studyUpdateTimestamp: 0,
    studyGuid: 0,
    segmentationStudyName: "",
    segmentOrdinal: 0,
    status: 0,
    ruidType: 0,
    segmentType: 0,
};
exports.StudyMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.metaValues).forEach(([key, value]) => {
            exports.StudyMetadata_MetaValuesEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.studyId !== "") {
            writer.uint32(18).string(message.studyId);
        }
        if (message.version !== 0) {
            writer.uint32(24).uint64(message.version);
        }
        writer.uint32(34).fork();
        for (const v of message.servePlatforms) {
            writer.int32(v);
        }
        writer.ldelim();
        for (const v of message.treatments) {
            exports.StudyMetadata_Treatment.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.whitelistedCondition !== undefined) {
            exports.StudyMetadata_WhitelistedCondition.encode(message.whitelistedCondition, writer.uint32(50).fork()).ldelim();
        }
        if (message.sliceRange !== undefined) {
            exports.StudyMetadata_UserSliceRange.encode(message.sliceRange, writer.uint32(58).fork()).ldelim();
        }
        if (message.options !== undefined) {
            exports.StudyMetadata_AdvancedOptions.encode(message.options, writer.uint32(66).fork()).ldelim();
        }
        if (message.targetingExpression !== undefined) {
            exports.StudyMetadata_TargetingExpression.encode(message.targetingExpression, writer.uint32(74).fork()).ldelim();
        }
        if (message.studyUpdateTimestamp !== 0) {
            writer.uint32(80).uint64(message.studyUpdateTimestamp);
        }
        if (message.studyGuid !== 0) {
            writer.uint32(96).uint64(message.studyGuid);
        }
        if (message.segmentationStudyName !== "") {
            writer.uint32(106).string(message.segmentationStudyName);
        }
        if (message.segmentOrdinal !== 0) {
            writer.uint32(112).int32(message.segmentOrdinal);
        }
        if (message.status !== 0) {
            writer.uint32(120).int32(message.status);
        }
        if (message.ruidType !== 0) {
            writer.uint32(128).int32(message.ruidType);
        }
        if (message.segmentType !== 0) {
            writer.uint32(136).int32(message.segmentType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata);
        message.metaValues = {};
        message.servePlatforms = [];
        message.treatments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.StudyMetadata_MetaValuesEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.metaValues[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.studyId = reader.string();
                    break;
                case 3:
                    message.version = longToNumber(reader.uint64());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.servePlatforms.push(reader.int32());
                        }
                    }
                    else {
                        message.servePlatforms.push(reader.int32());
                    }
                    break;
                case 5:
                    message.treatments.push(exports.StudyMetadata_Treatment.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.whitelistedCondition =
                        exports.StudyMetadata_WhitelistedCondition.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.sliceRange = exports.StudyMetadata_UserSliceRange.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.options = exports.StudyMetadata_AdvancedOptions.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.targetingExpression =
                        exports.StudyMetadata_TargetingExpression.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.studyUpdateTimestamp = longToNumber(reader.uint64());
                    break;
                case 12:
                    message.studyGuid = longToNumber(reader.uint64());
                    break;
                case 13:
                    message.segmentationStudyName = reader.string();
                    break;
                case 14:
                    message.segmentOrdinal = reader.int32();
                    break;
                case 15:
                    message.status = reader.int32();
                    break;
                case 16:
                    message.ruidType = reader.int32();
                    break;
                case 17:
                    message.segmentType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata);
        message.metaValues = {};
        message.servePlatforms = [];
        message.treatments = [];
        if (object.metaValues !== undefined && object.metaValues !== null) {
            Object.entries(object.metaValues).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.metaValues[key] = String(value);
                }
            });
        }
        if (object.studyId !== undefined && object.studyId !== null) {
            message.studyId = object.studyId;
        }
        else {
            message.studyId = "";
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        if (object.servePlatforms !== undefined && object.servePlatforms !== null) {
            for (const e of object.servePlatforms) {
                message.servePlatforms.push(e);
            }
        }
        if (object.treatments !== undefined && object.treatments !== null) {
            for (const e of object.treatments) {
                message.treatments.push(exports.StudyMetadata_Treatment.fromPartial(e));
            }
        }
        if (object.whitelistedCondition !== undefined &&
            object.whitelistedCondition !== null) {
            message.whitelistedCondition =
                exports.StudyMetadata_WhitelistedCondition.fromPartial(object.whitelistedCondition);
        }
        else {
            message.whitelistedCondition = undefined;
        }
        if (object.sliceRange !== undefined && object.sliceRange !== null) {
            message.sliceRange = exports.StudyMetadata_UserSliceRange.fromPartial(object.sliceRange);
        }
        else {
            message.sliceRange = undefined;
        }
        if (object.options !== undefined && object.options !== null) {
            message.options = exports.StudyMetadata_AdvancedOptions.fromPartial(object.options);
        }
        else {
            message.options = undefined;
        }
        if (object.targetingExpression !== undefined &&
            object.targetingExpression !== null) {
            message.targetingExpression =
                exports.StudyMetadata_TargetingExpression.fromPartial(object.targetingExpression);
        }
        else {
            message.targetingExpression = undefined;
        }
        if (object.studyUpdateTimestamp !== undefined &&
            object.studyUpdateTimestamp !== null) {
            message.studyUpdateTimestamp = object.studyUpdateTimestamp;
        }
        else {
            message.studyUpdateTimestamp = 0;
        }
        if (object.studyGuid !== undefined && object.studyGuid !== null) {
            message.studyGuid = object.studyGuid;
        }
        else {
            message.studyGuid = 0;
        }
        if (object.segmentationStudyName !== undefined &&
            object.segmentationStudyName !== null) {
            message.segmentationStudyName = object.segmentationStudyName;
        }
        else {
            message.segmentationStudyName = "";
        }
        if (object.segmentOrdinal !== undefined && object.segmentOrdinal !== null) {
            message.segmentOrdinal = object.segmentOrdinal;
        }
        else {
            message.segmentOrdinal = 0;
        }
        if (object.status !== undefined && object.status !== null) {
            message.status = object.status;
        }
        else {
            message.status = 0;
        }
        if (object.ruidType !== undefined && object.ruidType !== null) {
            message.ruidType = object.ruidType;
        }
        else {
            message.ruidType = 0;
        }
        if (object.segmentType !== undefined && object.segmentType !== null) {
            message.segmentType = object.segmentType;
        }
        else {
            message.segmentType = 0;
        }
        return message;
    },
};
const baseStudyMetadata_TargetingExpression = {
    operator: 0,
    property: 0,
    predicateOperator: 0,
    value: "",
};
exports.StudyMetadata_TargetingExpression = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.operator !== 0) {
            writer.uint32(8).int32(message.operator);
        }
        for (const v of message.children) {
            exports.StudyMetadata_TargetingExpression.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.property !== 0) {
            writer.uint32(24).int32(message.property);
        }
        if (message.predicateOperator !== 0) {
            writer.uint32(32).int32(message.predicateOperator);
        }
        if (message.value !== "") {
            writer.uint32(42).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_TargetingExpression);
        message.children = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operator = reader.int32();
                    break;
                case 2:
                    message.children.push(exports.StudyMetadata_TargetingExpression.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.property = reader.int32();
                    break;
                case 4:
                    message.predicateOperator = reader.int32();
                    break;
                case 5:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_TargetingExpression);
        message.children = [];
        if (object.operator !== undefined && object.operator !== null) {
            message.operator = object.operator;
        }
        else {
            message.operator = 0;
        }
        if (object.children !== undefined && object.children !== null) {
            for (const e of object.children) {
                message.children.push(exports.StudyMetadata_TargetingExpression.fromPartial(e));
            }
        }
        if (object.property !== undefined && object.property !== null) {
            message.property = object.property;
        }
        else {
            message.property = 0;
        }
        if (object.predicateOperator !== undefined &&
            object.predicateOperator !== null) {
            message.predicateOperator = object.predicateOperator;
        }
        else {
            message.predicateOperator = 0;
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
const baseStudyMetadata_Guid = { value: 0 };
exports.StudyMetadata_Guid = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.value !== 0) {
            writer.uint32(8).uint64(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_Guid);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.value = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_Guid);
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = 0;
        }
        return message;
    },
};
const baseStudyMetadata_Treatment = {
    experimentId: 0,
    trafficPercentage: 0,
    groupId: 0,
    budgetGroupId: 0,
};
exports.StudyMetadata_Treatment = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.experimentId !== 0) {
            writer.uint32(8).uint32(message.experimentId);
        }
        if (message.trafficPercentage !== 0) {
            writer.uint32(16).uint32(message.trafficPercentage);
        }
        Object.entries(message.experimentSettings).forEach(([key, value]) => {
            exports.StudyMetadata_Treatment_ExperimentSettingsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        if (message.groupId !== 0) {
            writer.uint32(32).uint32(message.groupId);
        }
        for (const v of message.override) {
            exports.StudyMetadata_Treatment_VariableOverrideMetadata.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.expGuid !== undefined) {
            exports.StudyMetadata_Guid.encode(message.expGuid, writer.uint32(50).fork()).ldelim();
        }
        if (message.budgetGroupId !== 0) {
            writer.uint32(56).uint32(message.budgetGroupId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_Treatment);
        message.experimentSettings = {};
        message.override = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.experimentId = reader.uint32();
                    break;
                case 2:
                    message.trafficPercentage = reader.uint32();
                    break;
                case 3:
                    const entry3 = exports.StudyMetadata_Treatment_ExperimentSettingsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.experimentSettings[entry3.key] = entry3.value;
                    }
                    break;
                case 4:
                    message.groupId = reader.uint32();
                    break;
                case 5:
                    message.override.push(exports.StudyMetadata_Treatment_VariableOverrideMetadata.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.expGuid = exports.StudyMetadata_Guid.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.budgetGroupId = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_Treatment);
        message.experimentSettings = {};
        message.override = [];
        if (object.experimentId !== undefined && object.experimentId !== null) {
            message.experimentId = object.experimentId;
        }
        else {
            message.experimentId = 0;
        }
        if (object.trafficPercentage !== undefined &&
            object.trafficPercentage !== null) {
            message.trafficPercentage = object.trafficPercentage;
        }
        else {
            message.trafficPercentage = 0;
        }
        if (object.experimentSettings !== undefined &&
            object.experimentSettings !== null) {
            Object.entries(object.experimentSettings).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.experimentSettings[key] = String(value);
                }
            });
        }
        if (object.groupId !== undefined && object.groupId !== null) {
            message.groupId = object.groupId;
        }
        else {
            message.groupId = 0;
        }
        if (object.override !== undefined && object.override !== null) {
            for (const e of object.override) {
                message.override.push(exports.StudyMetadata_Treatment_VariableOverrideMetadata.fromPartial(e));
            }
        }
        if (object.expGuid !== undefined && object.expGuid !== null) {
            message.expGuid = exports.StudyMetadata_Guid.fromPartial(object.expGuid);
        }
        else {
            message.expGuid = undefined;
        }
        if (object.budgetGroupId !== undefined && object.budgetGroupId !== null) {
            message.budgetGroupId = object.budgetGroupId;
        }
        else {
            message.budgetGroupId = 0;
        }
        return message;
    },
};
const baseStudyMetadata_Treatment_VariableOverrideMetadata = {
    namespace: "",
    id: "",
    typeName: "",
};
exports.StudyMetadata_Treatment_VariableOverrideMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.namespace !== "") {
            writer.uint32(10).string(message.namespace);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        if (message.override !== undefined) {
            value_1.Value.encode(message.override, writer.uint32(26).fork()).ldelim();
        }
        if (message.fileDescriptorProto !== undefined) {
            descriptor_1.FileDescriptorProto.encode(message.fileDescriptorProto, writer.uint32(34).fork()).ldelim();
        }
        if (message.typeName !== "") {
            writer.uint32(42).string(message.typeName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_Treatment_VariableOverrideMetadata);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.id = reader.string();
                    break;
                case 3:
                    message.override = value_1.Value.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.fileDescriptorProto = descriptor_1.FileDescriptorProto.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.typeName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_Treatment_VariableOverrideMetadata);
        if (object.namespace !== undefined && object.namespace !== null) {
            message.namespace = object.namespace;
        }
        else {
            message.namespace = "";
        }
        if (object.id !== undefined && object.id !== null) {
            message.id = object.id;
        }
        else {
            message.id = "";
        }
        if (object.override !== undefined && object.override !== null) {
            message.override = value_1.Value.fromPartial(object.override);
        }
        else {
            message.override = undefined;
        }
        if (object.fileDescriptorProto !== undefined &&
            object.fileDescriptorProto !== null) {
            message.fileDescriptorProto = descriptor_1.FileDescriptorProto.fromPartial(object.fileDescriptorProto);
        }
        else {
            message.fileDescriptorProto = undefined;
        }
        if (object.typeName !== undefined && object.typeName !== null) {
            message.typeName = object.typeName;
        }
        else {
            message.typeName = "";
        }
        return message;
    },
};
const baseStudyMetadata_Treatment_ExperimentSettingsEntry = {
    key: "",
    value: "",
};
exports.StudyMetadata_Treatment_ExperimentSettingsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_Treatment_ExperimentSettingsEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_Treatment_ExperimentSettingsEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
const baseStudyMetadata_UserSliceRange = {
    namespace: "",
    start: 0,
    end: 0,
};
exports.StudyMetadata_UserSliceRange = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.namespace !== "") {
            writer.uint32(10).string(message.namespace);
        }
        if (message.start !== 0) {
            writer.uint32(16).uint32(message.start);
        }
        if (message.end !== 0) {
            writer.uint32(24).uint32(message.end);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_UserSliceRange);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.namespace = reader.string();
                    break;
                case 2:
                    message.start = reader.uint32();
                    break;
                case 3:
                    message.end = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_UserSliceRange);
        if (object.namespace !== undefined && object.namespace !== null) {
            message.namespace = object.namespace;
        }
        else {
            message.namespace = "";
        }
        if (object.start !== undefined && object.start !== null) {
            message.start = object.start;
        }
        else {
            message.start = 0;
        }
        if (object.end !== undefined && object.end !== null) {
            message.end = object.end;
        }
        else {
            message.end = 0;
        }
        return message;
    },
};
const baseStudyMetadata_WhitelistedUserGroups = {
    treatmentId: 0,
    userGroupNames: "",
};
exports.StudyMetadata_WhitelistedUserGroups = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.treatmentId !== 0) {
            writer.uint32(8).uint32(message.treatmentId);
        }
        for (const v of message.userGroupNames) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_WhitelistedUserGroups);
        message.userGroupNames = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.treatmentId = reader.uint32();
                    break;
                case 2:
                    message.userGroupNames.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_WhitelistedUserGroups);
        message.userGroupNames = [];
        if (object.treatmentId !== undefined && object.treatmentId !== null) {
            message.treatmentId = object.treatmentId;
        }
        else {
            message.treatmentId = 0;
        }
        if (object.userGroupNames !== undefined && object.userGroupNames !== null) {
            for (const e of object.userGroupNames) {
                message.userGroupNames.push(e);
            }
        }
        return message;
    },
};
const baseStudyMetadata_WhitelistedCondition = {};
exports.StudyMetadata_WhitelistedCondition = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.whitelistedUserBucketMap).forEach(([key, value]) => {
            exports.StudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        for (const v of message.whitelistedUserGroups) {
            exports.StudyMetadata_WhitelistedUserGroups.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_WhitelistedCondition);
        message.whitelistedUserBucketMap = {};
        message.whitelistedUserGroups = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.StudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.whitelistedUserBucketMap[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.whitelistedUserGroups.push(exports.StudyMetadata_WhitelistedUserGroups.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_WhitelistedCondition);
        message.whitelistedUserBucketMap = {};
        message.whitelistedUserGroups = [];
        if (object.whitelistedUserBucketMap !== undefined &&
            object.whitelistedUserBucketMap !== null) {
            Object.entries(object.whitelistedUserBucketMap).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.whitelistedUserBucketMap[key] = Number(value);
                }
            });
        }
        if (object.whitelistedUserGroups !== undefined &&
            object.whitelistedUserGroups !== null) {
            for (const e of object.whitelistedUserGroups) {
                message.whitelistedUserGroups.push(exports.StudyMetadata_WhitelistedUserGroups.fromPartial(e));
            }
        }
        return message;
    },
};
const baseStudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry = { key: "", value: 0 };
exports.StudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== 0) {
            writer.uint32(16).uint32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_WhitelistedCondition_WhitelistedUserBucketMapEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = 0;
        }
        return message;
    },
};
const baseStudyMetadata_AdvancedOptions = {
    seed: "",
    isForNewUser: false,
    newUserTs: 0,
    isDeviceLevel: false,
    isUserIdTargeting: false,
};
exports.StudyMetadata_AdvancedOptions = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.seed !== "") {
            writer.uint32(10).string(message.seed);
        }
        if (message.isForNewUser === true) {
            writer.uint32(16).bool(message.isForNewUser);
        }
        if (message.newUserTs !== 0) {
            writer.uint32(24).uint64(message.newUserTs);
        }
        if (message.isDeviceLevel === true) {
            writer.uint32(32).bool(message.isDeviceLevel);
        }
        if (message.isUserIdTargeting === true) {
            writer.uint32(40).bool(message.isUserIdTargeting);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_AdvancedOptions);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.seed = reader.string();
                    break;
                case 2:
                    message.isForNewUser = reader.bool();
                    break;
                case 3:
                    message.newUserTs = longToNumber(reader.uint64());
                    break;
                case 4:
                    message.isDeviceLevel = reader.bool();
                    break;
                case 5:
                    message.isUserIdTargeting = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_AdvancedOptions);
        if (object.seed !== undefined && object.seed !== null) {
            message.seed = object.seed;
        }
        else {
            message.seed = "";
        }
        if (object.isForNewUser !== undefined && object.isForNewUser !== null) {
            message.isForNewUser = object.isForNewUser;
        }
        else {
            message.isForNewUser = false;
        }
        if (object.newUserTs !== undefined && object.newUserTs !== null) {
            message.newUserTs = object.newUserTs;
        }
        else {
            message.newUserTs = 0;
        }
        if (object.isDeviceLevel !== undefined && object.isDeviceLevel !== null) {
            message.isDeviceLevel = object.isDeviceLevel;
        }
        else {
            message.isDeviceLevel = false;
        }
        if (object.isUserIdTargeting !== undefined &&
            object.isUserIdTargeting !== null) {
            message.isUserIdTargeting = object.isUserIdTargeting;
        }
        else {
            message.isUserIdTargeting = false;
        }
        return message;
    },
};
const baseStudyMetadata_SegmentExperiment = {
    expId: 0,
    trafficPercentage: 0,
};
exports.StudyMetadata_SegmentExperiment = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.expId !== 0) {
            writer.uint32(8).uint32(message.expId);
        }
        if (message.trafficPercentage !== 0) {
            writer.uint32(16).uint32(message.trafficPercentage);
        }
        Object.entries(message.experimentSettings).forEach(([key, value]) => {
            exports.StudyMetadata_SegmentExperiment_ExperimentSettingsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_SegmentExperiment);
        message.experimentSettings = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.expId = reader.uint32();
                    break;
                case 2:
                    message.trafficPercentage = reader.uint32();
                    break;
                case 3:
                    const entry3 = exports.StudyMetadata_SegmentExperiment_ExperimentSettingsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.experimentSettings[entry3.key] = entry3.value;
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_SegmentExperiment);
        message.experimentSettings = {};
        if (object.expId !== undefined && object.expId !== null) {
            message.expId = object.expId;
        }
        else {
            message.expId = 0;
        }
        if (object.trafficPercentage !== undefined &&
            object.trafficPercentage !== null) {
            message.trafficPercentage = object.trafficPercentage;
        }
        else {
            message.trafficPercentage = 0;
        }
        if (object.experimentSettings !== undefined &&
            object.experimentSettings !== null) {
            Object.entries(object.experimentSettings).forEach(([key, value]) => {
                if (value !== undefined) {
                    message.experimentSettings[key] = String(value);
                }
            });
        }
        return message;
    },
};
const baseStudyMetadata_SegmentExperiment_ExperimentSettingsEntry = {
    key: "",
    value: "",
};
exports.StudyMetadata_SegmentExperiment_ExperimentSettingsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_SegmentExperiment_ExperimentSettingsEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_SegmentExperiment_ExperimentSettingsEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
const baseStudyMetadata_Segment = { version: 0 };
exports.StudyMetadata_Segment = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.targetingExpression !== undefined) {
            exports.StudyMetadata_TargetingExpression.encode(message.targetingExpression, writer.uint32(10).fork()).ldelim();
        }
        if (message.sliceRange !== undefined) {
            exports.StudyMetadata_UserSliceRange.encode(message.sliceRange, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.experiments) {
            exports.StudyMetadata_SegmentExperiment.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.version !== 0) {
            writer.uint32(32).uint32(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_Segment);
        message.experiments = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.targetingExpression =
                        exports.StudyMetadata_TargetingExpression.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sliceRange = exports.StudyMetadata_UserSliceRange.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.experiments.push(exports.StudyMetadata_SegmentExperiment.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.version = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_Segment);
        message.experiments = [];
        if (object.targetingExpression !== undefined &&
            object.targetingExpression !== null) {
            message.targetingExpression =
                exports.StudyMetadata_TargetingExpression.fromPartial(object.targetingExpression);
        }
        else {
            message.targetingExpression = undefined;
        }
        if (object.sliceRange !== undefined && object.sliceRange !== null) {
            message.sliceRange = exports.StudyMetadata_UserSliceRange.fromPartial(object.sliceRange);
        }
        else {
            message.sliceRange = undefined;
        }
        if (object.experiments !== undefined && object.experiments !== null) {
            for (const e of object.experiments) {
                message.experiments.push(exports.StudyMetadata_SegmentExperiment.fromPartial(e));
            }
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        return message;
    },
};
const baseStudyMetadata_MetaValuesEntry = { key: "", value: "" };
exports.StudyMetadata_MetaValuesEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStudyMetadata_MetaValuesEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseStudyMetadata_MetaValuesEntry);
        if (object.key !== undefined && object.key !== null) {
            message.key = object.key;
        }
        else {
            message.key = "";
        }
        if (object.value !== undefined && object.value !== null) {
            message.value = object.value;
        }
        else {
            message.value = "";
        }
        return message;
    },
};
const baseUpdateStudyMetadataResponse = {};
exports.UpdateStudyMetadataResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateStudyMetadataResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseUpdateStudyMetadataResponse);
        return message;
    },
};
const baseDeleteStudyMetadataRequest = { segmentationStudyName: "" };
exports.DeleteStudyMetadataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studiesToDelete) {
            exports.DeleteStudyMetadataRequest_StudyIdentity.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.segmentationStudyName !== "") {
            writer.uint32(18).string(message.segmentationStudyName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDeleteStudyMetadataRequest);
        message.studiesToDelete = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studiesToDelete.push(exports.DeleteStudyMetadataRequest_StudyIdentity.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.segmentationStudyName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDeleteStudyMetadataRequest);
        message.studiesToDelete = [];
        if (object.studiesToDelete !== undefined &&
            object.studiesToDelete !== null) {
            for (const e of object.studiesToDelete) {
                message.studiesToDelete.push(exports.DeleteStudyMetadataRequest_StudyIdentity.fromPartial(e));
            }
        }
        if (object.segmentationStudyName !== undefined &&
            object.segmentationStudyName !== null) {
            message.segmentationStudyName = object.segmentationStudyName;
        }
        else {
            message.segmentationStudyName = "";
        }
        return message;
    },
};
const baseDeleteStudyMetadataRequest_StudyIdentity = {
    studyId: "",
    version: 0,
};
exports.DeleteStudyMetadataRequest_StudyIdentity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.studyId !== "") {
            writer.uint32(10).string(message.studyId);
        }
        if (message.version !== 0) {
            writer.uint32(16).uint64(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDeleteStudyMetadataRequest_StudyIdentity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyId = reader.string();
                    break;
                case 2:
                    message.version = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDeleteStudyMetadataRequest_StudyIdentity);
        if (object.studyId !== undefined && object.studyId !== null) {
            message.studyId = object.studyId;
        }
        else {
            message.studyId = "";
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        return message;
    },
};
const baseDeleteStudyMetadataResponse = {};
exports.DeleteStudyMetadataResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDeleteStudyMetadataResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseDeleteStudyMetadataResponse);
        return message;
    },
};
const baseFetchStudyMetadataRequest = {
    namespaces: "",
    fetchAllStudies: false,
};
exports.FetchStudyMetadataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studies) {
            exports.FetchStudyMetadataRequest_StudyIdentity.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.namespaces) {
            writer.uint32(18).string(v);
        }
        if (message.fetchAllStudies === true) {
            writer.uint32(24).bool(message.fetchAllStudies);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseFetchStudyMetadataRequest);
        message.studies = [];
        message.namespaces = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studies.push(exports.FetchStudyMetadataRequest_StudyIdentity.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.namespaces.push(reader.string());
                    break;
                case 3:
                    message.fetchAllStudies = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseFetchStudyMetadataRequest);
        message.studies = [];
        message.namespaces = [];
        if (object.studies !== undefined && object.studies !== null) {
            for (const e of object.studies) {
                message.studies.push(exports.FetchStudyMetadataRequest_StudyIdentity.fromPartial(e));
            }
        }
        if (object.namespaces !== undefined && object.namespaces !== null) {
            for (const e of object.namespaces) {
                message.namespaces.push(e);
            }
        }
        if (object.fetchAllStudies !== undefined &&
            object.fetchAllStudies !== null) {
            message.fetchAllStudies = object.fetchAllStudies;
        }
        else {
            message.fetchAllStudies = false;
        }
        return message;
    },
};
const baseFetchStudyMetadataRequest_StudyIdentity = {
    studyId: "",
    version: 0,
};
exports.FetchStudyMetadataRequest_StudyIdentity = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.studyId !== "") {
            writer.uint32(10).string(message.studyId);
        }
        if (message.version !== 0) {
            writer.uint32(16).uint64(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseFetchStudyMetadataRequest_StudyIdentity);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyId = reader.string();
                    break;
                case 2:
                    message.version = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseFetchStudyMetadataRequest_StudyIdentity);
        if (object.studyId !== undefined && object.studyId !== null) {
            message.studyId = object.studyId;
        }
        else {
            message.studyId = "";
        }
        if (object.version !== undefined && object.version !== null) {
            message.version = object.version;
        }
        else {
            message.version = 0;
        }
        return message;
    },
};
const baseFetchStudyMetadataResponse = {};
exports.FetchStudyMetadataResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.studyMetadata) {
            exports.StudyMetadata.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseFetchStudyMetadataResponse);
        message.studyMetadata = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.studyMetadata.push(exports.StudyMetadata.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseFetchStudyMetadataResponse);
        message.studyMetadata = [];
        if (object.studyMetadata !== undefined && object.studyMetadata !== null) {
            for (const e of object.studyMetadata) {
                message.studyMetadata.push(exports.StudyMetadata.fromPartial(e));
            }
        }
        return message;
    },
};
const baseHealthCheckRequest = {};
exports.HealthCheckRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseHealthCheckRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseHealthCheckRequest);
        return message;
    },
};
const baseHealthCheckResponse = { healthCheckStatus: "" };
exports.HealthCheckResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.healthCheckStatus !== "") {
            writer.uint32(10).string(message.healthCheckStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseHealthCheckResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.healthCheckStatus = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseHealthCheckResponse);
        if (object.healthCheckStatus !== undefined &&
            object.healthCheckStatus !== null) {
            message.healthCheckStatus = object.healthCheckStatus;
        }
        else {
            message.healthCheckStatus = "";
        }
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=ab_config_service.js.map